/*
* This File's code will only gets called on PDP page...
* Condition for running only specific API rather than running all at the PDP page...
* Particuler Tags will run particuler API's...  
*/
var nameColorDropDown = currentProductJson ? currentProductJson.tags.filter(s => s.includes('color-dropdown')) : [];
var namePearStone = currentProductJson ? currentProductJson.tags.filter(s => s.includes('pear-stone') || s.includes('cloud-pear-stone')) : [];
var nameEmeraldStone = currentProductJson ? currentProductJson.tags.filter(s => s.includes('emerald-stone') || s.includes('cloud-emerald-stone')) : [];
var nameMensSize = currentProductJson ? currentProductJson.tags.filter(s => s.includes('mens-size')) : [];
var nameWomensSize = currentProductJson ? currentProductJson.tags.filter(s => s.includes('womens-size')) : [];

if (nameColorDropDown && nameColorDropDown.length != 0) {
  colorDropdownArray();
}
if (namePearStone && namePearStone.length != 0) {
  pearstoneDropdownArray();
}
if (nameEmeraldStone && nameEmeraldStone.length != 0) {
  emeraldstoneDropdownArray();
}
if (nameMensSize && nameMensSize.length != 0) {
  mensSizeDropdownArray();
}
if (nameWomensSize && nameWomensSize.length != 0) {
  womensSizeDropdownArray();
}

/**
* document.addEventListener('variant:changed', function(event) {
*   var variant = event.detail.variant; // Gives you access to the whole variant details
* });
*/
document.addEventListener("variant:changed", function (e) {
  var variant = e.detail.variant
  currentVariantJson = variant
  var productId = jQuery("#pageActionProduct").attr('productId')
  var productTag = jQuery("#pageActionProduct").attr('productTag')
  var nameCountProduct = currentProductJson.tags.filter(s => s.includes('name-count'));
  var checkPreOrderProduct = currentProductJson.tags.filter(s => s.includes('pre-order-product'));
  var checkButtonText = $('.ProductForm__AddToCart').text().toLowerCase();
  var enableImageAssociation = currentProductJson.tags.filter(s => s.includes('show-associated-images'));
  var showFirstGalleryImage = currentProductJson.tags.filter(s => s.includes('show-first-gallery-image'));
  $('.ProductForm__AddToCart').addClass('BlackWhiteCustomizer').attr("data-action", "add-to-cart-with-wishlist");
  // For Multiple Product Combine Template
  if (variant) {
    executeStockLevelMessages(variant, false, function (error, data) { })
    // to add clock icon class
    var textclock = $('.stock-level-message').text();
    if (textclock.search("Estimated") != -1) {
      $('.custom-stock-level-message').addClass('clock-enabled')
    } else {
      $('.custom-stock-level-message').removeClass('clock-enabled')
    }
    /* ===== Update Data Attribute params for Price ===== */
    $('#appendReg, #appendSale, #appendCompareAt').attr('data-variant-id', variant.id);
  }

  var updateDropdownValues = currentProductJson ? currentProductJson.tags.filter(s => s.startsWith('update-dropdown-values: ')).map(s => s.replace('update-dropdown-values: ', '')) : [];
  if(updateDropdownValues && updateDropdownValues.length !== 0){
    updateDropdwonValuesInUI(updateDropdownValues[0]);
  }

  /* Calling Associate Variant Image function on Variant Change */
  if(enableImageAssociation && enableImageAssociation.length) {
    associateVariantImageToSlider()
  }
  /* Show First Gallery Image functionality: Assign Image on Variant Changes */
  if(showFirstGalleryImage && showFirstGalleryImage.length) {
    updateVarianImage(variant)
  }
  updateDropdownInventoryOptions()
  customStoneCount(variant, productId, productTag)
  customHeart(variant)
  customMiniHeart(variant)
  pearstoneDropDown(variant)
  emeraldstoneDropDown(variant)
  zodiacOneProductDropDown(variant)
  zodiacTwoProductDropDown(variant)
  customSizeDropDown(variant)
  mensSizeDropDown(variant)
  womensSizeDropDown(variant)
  colorDropDown(variant)
  if (nameCountProduct && nameCountProduct.length != 0) {
    namecount(variant)
  }
  executeDontKnowYourSize(variant)
  getVariantSkuDetails(variant)
  setLineItemPropAboveOneKPrice(variant)
  selectedVariant(variant)
  checkCustomizationValues(variant)
  setConditionForCustomization(variant)
  setFontFamilyToPreview(variant)
  grabSelectedVariant(variant)
  toietmoiViewCombination()
  bespokeProductWarningPopup(variant)
  updateVariantInterlinking(variant)
  var getProductTypeLower = getProductType.toLowerCase();
  if (!(getProductTypeLower.includes('mens rings') || getProductTypeLower.includes('wedding bands')) && !currentProductJson.tags.includes('hide-pdp-add-to-bag')) {
    addToCartButtonMobile();
  }
  if (!$('#js-customization-required').hasClass("line-item-property__field")) {
    engravefont();
  }
  if (checkPreOrderProduct && checkPreOrderProduct.length != 0) {
    preOrderFunctionality(variant)
    addPropertyForPreOrder(variant)
  }
  /* Preview combination image on change of variant for specific products */
  if (currentProductJson.id === 7587125133400 || currentProductJson.id === 7435379802200 || currentProductJson.id === 7502665908312 || currentProductJson.id === 7435379507288 || currentProductJson.id === 7502659813464){
    previewColorCombinationButton("_engraving_image")
  }
  if (currentProductJson.id === 7973256822872 || currentProductJson.id === 7973232869464){
    previewColorCombinationButton("_signet_ring")
  }
    
  updCharLimit(e.target);
  var inputELem = $(e.target).find(".line-item-property__field input.vow-form-control-light");
  getFont(inputELem);
  if (checkButtonText.indexOf('sold out') > -1) {
    $('.mejuri-card').hide();
    disableAddToCartButton();
    $('.checkoutNowButton').prop('disabled', true);
  } else {
    $('.mejuri-card').show();
    $('.checkoutNowButton').prop('disabled', false);
    enableAddToCartButton();
  }
  /* Grab Dynamic Add to Bag CTA Text */
  var grabText = $(".ProductForm__AddToCart")?.text().toLowerCase().replace(" ", "");
  if (grabAddToBagText && grabAddToBagText !== ''){
    if(grabText !== 'soldout' && grabText !== 'comingsoon'){
      $(".ProductForm__AddToCart span:not(.jsAddtocartFinalSale):not(.addtocart-final-sale)").first().text(grabAddToBagText);
    }
  }
  /* Getting Dynamic Estimated Lead Time on Variant Change */
  if (dynamicEstimatedLeadTime !== 'turnoff') {
    try {
      $.get("https://get.geojs.io/v1/ip/geo.json", async function (response) {
        var visitorCountry = response.country;
        var visitorCountryCode = response.country_code;
        if ((visitorCountry && visitorCountry.toUpperCase() === 'UNITED STATES') || (visitorCountryCode && visitorCountryCode.toUpperCase() === 'US')) {
          grabDynamicShippingDate = await getDynamicShippingDate();
        }
      })
    } catch (error) {
      console.error("Error while getting dynamic shipping date:", error);
    }
  }
  if (currentProductTemplate === 'default-2-0-meta-teaser'){
    $('.ProductForm__AddToCart').text(grabTeaserBtnText).prop('disabled', true);
  }
})

/* Formatting Price */
var formatPriceFuncCharmLocket = (price) => {
  price = Number(price); // ensure it's a number
  return price.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
}

/*** Fetch color dropdown variants Array function ***/
var colordropOptions = [];
function colorDropdownArray() {
  getProductByHandle(`color-dropdown`)
    .then(function (colordropdownGhostProduct) {
      var optionsArr = []
      for (var i = 0; i < colordropdownGhostProduct.product.variants.length; i++) {
        var filteredNames = $(colordropdownGhostProduct.product.images).filter(function (idx) {
          return colordropdownGhostProduct.product.images[idx].id === colordropdownGhostProduct.product.variants[i].image_id
        });
        $(filteredNames).each(function () {
          colordropdownGhostProduct.product.variants[i].imageUrl = this.src;
        })
      }
      return colordropdownGhostProduct.product.variants;
    }).then(function (options) {
      colordropOptions = options
      return colordropOptions
    })
}

function updateDropdwonValuesInUI(value){
  if (!value) return; 
  var getSelectedQuantityValue = getOptionsVals(currentVariantJson, value);
  var ifCaratWeightFieldIsPresent = jQuery('form[action="/cart/add"]').find(`input[name="properties[Carat_Weight]"]`).length;
  var element = $("."+value+".ProductForm__Option.ProductForm__Option--labelled").next();
  for(let i=0; i<dropDownValuesJSON[getSelectedQuantityValue].length; i++){
    element.find(".Popover__ValueList").find("button").eq(i).contents().filter(function() { return this.nodeType === 3; }).first().replaceWith(dropDownValuesJSON[getSelectedQuantityValue][i]);
  }
  var value = element.find(".Popover__ValueList").find("button.is-selected").contents().filter(function() { return this.nodeType === 3; }).text().trim();
  element.find(".ProductForm__SelectedValue").text(value);
  if (ifCaratWeightFieldIsPresent > 0) {
    jQuery('form[action="/cart/add"]').find(`input[name="properties[Carat_Weight]"]`).attr("value", value)
  } else {
    jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Carat_Weight]" value="`+ value +`" />`)
  }
}

/* Append Selected Variant Feature Image: Show First Gallery Image Functionality */
function updateVarianImage(variant) {
  var selectedImageId = variant.featured_image?.id;
  $(`button[data-image-id="${selectedImageId}"]`).trigger("click");
}

/* Updating the URL param for Variant Interlinking */
function updateVariantInterlinking(variant) {
  const diamondRingVariants = {
    '1.3-perfect-pave-diamond-ring': {
      'Half': '/products/perfect-pave-diamond-ring-half-platinum?variant=41820975923288',
      'Eternity': '/products/perfect-pave-diamond-ring-eternity-platinum?variant=41821686956120'
    },
    '1.6-perfect-pave-diamond-ring': {
      'Half': '/products/perfect-pave-diamond-ring-half-platinum?variant=41820976676952',
      'Eternity': '/products/perfect-pave-diamond-ring-eternity-platinum?variant=41821688070232'
    },
    '1.9-perfect-pave-diamond-ring': {
      'Half': '/products/perfect-pave-diamond-ring-half-platinum?variant=41820977791064',
      'Eternity': '/products/perfect-pave-diamond-ring-eternity-platinum?variant=41821689184344'
    },
    '2.5-perfect-pave-diamond-ring': {
      'Half': '/products/perfect-pave-diamond-ring-half-platinum?variant=41820979265624',
      'Eternity': '/products/perfect-pave-diamond-ring-eternity-platinum?variant=41821690298456'
    }
  };

  const grabSelectedValue = getOptionsVals(variant, 'Diamond Coverage');
  const productTags = currentProductJson.tags;
  // Iterate over the diamond ring variants and check if they match the selected value and tags
  Object.keys(diamondRingVariants).forEach(tag => {
    if (productTags.includes(tag) && diamondRingVariants[tag][grabSelectedValue]) {
      const productUrl = diamondRingVariants[tag][grabSelectedValue];
      $('.interlinkingProduct-' + currentProductJson.id).attr('onclick', `window.location.href='${productUrl}'`);
    }
  });
}

/* PDP: Loading Flickity Settings on page load */
if (pageType === 'product' && currentProductTemplate && currentProductTemplate !== 'vow.engagement.rings') {
  flickitySettings();
}

/* Flickity slider for style with it (bridal) page */
$(document).ready(function () {
  var $carousel = $('.main-carousel').flickity({
    imagesLoaded: true,
    fullscreen: true,
    initialIndex: 1,
  });
  
  $('.diamond-shape-carousel').each(function () {
    $(this).flickity({
      prevNextButtons: true,
      pageDots: false,
      wrapAround: false,
      contain: true,
      draggable: false,
      cellAlign: "left",
      groupCells: true,
      arrowShape: { "x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25 }
    });
  });
  $(".checkoutNowButton").removeAttr("disabled","disabled")  
  $(".Modal__Close").on('click',function() {
    $("html").removeClass("no-scroll")
  })
});

/* ***Flickity Slider PDP settings*** */
function flickitySettings() {
  var carousel_2 = document.querySelector("body .Product__SlideshowNavScroller");
  var flickity_2 = new Flickity("body .Product__SlideshowNavScroller", {
    asNavFor: ".pdp-product-slideshow",
    initialIndex: 0,
    accessibility: true,
    contain: true,
    cellAlign: 'center',
    prevNextButtons: false,
    groupCells: 1,
    lazyLoad: false,
    bgLazyLoad: false,
    autoPlay: false,
    adaptiveHeight: false,
    pageDots: false,
    percentPosition: false,
    dragThreshold: 10,
    wrapAround: false
  })
  $(document).mousemove(function () {
    if ($(".Product__SlideshowNav:hover").length != 0) {
      $('body').addClass("is-flickity-scroll");
    } else {
      $('body').removeClass("is-flickity-scroll");
    }
  });
}

/* *** Vertical Scrollbar Previous/Next Button working *** */
setTimeout(() => {
  var getScrollBar = document.querySelector('.Product__SlideshowNavScroller .flickity-slider')
  var verticalScrollbar = $(".Product__SlideshowNavScroller .flickity-slider");
  if (verticalScrollbar) {
    verticalScrollbar.mousewheel(function (event) {
      event.preventDefault();
      getScrollBar.scrollBy({
        left: event.deltaY < 0 ? 20 : -20
      });
      handleFlickityButtons();
    });
    $('.flickity-previous-button').click(function () {
      verticalScrollbar.scrollLeft(verticalScrollbar.scrollLeft() - 120);
      handleFlickityButtons();
    })
    $('.flickity-next-button').click(function () {
      verticalScrollbar.scrollLeft(verticalScrollbar.scrollLeft() + 120);
      handleFlickityButtons();
    })
  }
}, 2000)

/* ***Custom flickity Previous/Next button functionality*** */
function handleFlickityButtons() {
  var scrollBarDiv = $('.Product__SlideshowNavScroller .flickity-slider');
  var scrollBarWidth = scrollBarDiv.outerWidth();
  var scrollWidth = scrollBarDiv[0]?.scrollWidth;
  var scrollLeft = scrollBarDiv.scrollLeft();
  scrollWidth - scrollBarWidth === scrollLeft ? $('.flickity-next-button').prop('disabled', true) : $('.flickity-next-button').prop('disabled', false);
  scrollLeft === 0 ? $('.flickity-previous-button').prop('disabled', true) : $('.flickity-previous-button').prop('disabled', false);
}

/* Checking the Send as a gift Button in Gift Card Product and removing it */
if (currentProductJson && currentProductJson.id == 1367003594840) {
  var secondAddToCartButton = setInterval(removeAddToCartClass, 1000);
  function removeAddToCartClass() {
    if ($(".ProductForm").find(".ProductForm__AddToCart").eq(1).length > 0) {
      $(".ProductForm").find(".ProductForm__AddToCart").eq(1).removeClass("ProductForm__AddToCart");
      clearInterval(secondAddToCartButton);
    }
  }
}

/* Mobile: Remove Div if Heading and subheading is not present: Bold Geometry Section */
if ($(window).width() < 768 === true) {
  if ($('.bold-geometry-block-valign').children().length === 0) {
    $('.bold-geometry-block').remove()
  }
}

/* Mobile: Show Add to cart on functionality */
if(!currentProductJson.tags.includes('hide-pdp-add-to-bag')) {
  var button = $('.ProductForm__AddToCart');
  if (currentProductTemplate && currentProductTemplate !== 'vow.engagement.rings') {
    var offset = button.offset().top + button.outerHeight();
    var getProductTypeLower = getProductType.toLowerCase();
    if (getProductTypeLower.includes('wedding bands')) {
      offset = button.offset().top + button.outerHeight() + 220;
    } else {
      offset = button.offset().top + button.outerHeight() + 150;
    }
  }
}

function addToCartButtonMobile() {
  if ($(this).scrollTop() >= offset) {
    $('.ProductForm__AddToCart').addClass('AddToCart_Mobile');
    $('body').addClass('addToCartStickyBubble');
    $('.swym-add-to-wishlist-view-product').addClass('wishlist-fixed-button')
  } else {
    $('.ProductForm__AddToCart').removeClass('AddToCart_Mobile');
    $('body').removeClass('addToCartStickyBubble');
    $('.swym-add-to-wishlist-view-product').removeClass('wishlist-fixed-button')
  }
}

/* Stop Screen Freeze */
stopScreenFreeze();

/* Add to cart Button Mobile Hide/Show */
var $window = $(window); // Cache the window object
if ($window.width() < 980) {
  $window.on('scroll', function () {
    if(!currentProductJson.tags.includes('hide-pdp-add-to-bag')) {
      addToCartButtonMobile();
    }
  });
}

/* Pause all the videos by default */
$("video").each(function () {
  this.pause();
});

/* This function works on slider image change */
var setTextColor = (cell = '') => {
  setTimeout(() => {
    if (cell) {
      var image_id = parseInt(cell.getAttribute('data-image-id'));
      var image_bg = cell.getAttribute('data-image-bg');
      $('.pdp-product-gallery').removeClass('image--black');
      if (image_bg == 'black') {
        $('.pdp-product-gallery').addClass('image--black');
      }
      // Pause all videos
      $("video").each(function () {
        this.pause();
      }); 
      /* Play Video If Video Contains Audio and handle iOS restrictions */
      if (cell.getAttribute('class').indexOf('Product__SlideItem--video') !== -1) {
        var videoElement = cell.querySelector("video");
        if (videoElement) {
          $(".videoPlayerButton").removeClass("iconPause").addClass("iconPlay")
        }
      }
    }
  }, 100);
}
document.addEventListener('image:changed', function (event) {
  var cell = event.detail.cell;
  setTextColor(cell);
});

/* Product slideshow image aspect ratio */
function productAspectgallery() {
  var sliderHeight = $('.pdp-product-slideshow .Product__SlideItem--image').height();
  var newWindowWidth = $(window).width();
  var widthToReduce = 84;
  if (newWindowWidth > 1201) {
    widthToReduce = 104;
  }
  $('.Product__SlideshowNav .carousel-nav').css({ 'width': ((sliderHeight) - widthToReduce) + 'px' });
  $(".pdp-product-gallery").height(sliderHeight);
}

productAspectgallery()
$(window).resize(function () {
  productAspectgallery()
});

$(function () {
  // RC-57-PDP-notify-me on click email field removes disabled attribute on the button / RC-294 VQA bug fix */
  $(".notify-container .vow-form-control").on("click", function () {
    $('.notify-form .Button--secondary').removeAttr("disabled");
    $('.notify-form .form-label').removeClass("hidden");
  });
  $(".notify-container .vow-form-control").on("blur", function () {
    if ($(this).val() === '') {
      $('.notify-form .Button--secondary').prop('disabled', true);
      $('.notify-form .form-label').addClass("hidden");
    }
  });
});

function changeImage(e) {
  var optionName = $(e).data('shape-option')
  $('[data-value="' + optionName + '"]').trigger('click')
  $(e).parents('.diamond-shape-list').find('li').removeClass('active')
  $(e).parent().addClass('active')
}

/* Wedding Date Picker: Mens Rings & Wedding band Collection */
$(function () {
  $("#propertiesAnotherDate").datepicker({
    minDate: '0'
  });
});
$("#weddingDateopen").on("click", function () {
  $('#propertiesAnotherDate').val('');
  $("#weddingDateSelector").show();
  $("body").css("overflow", "hidden");
});
$(".close-modal-popup").on("click", function () {
  $("#weddingDateSelector").hide();
});
$(".modaloverlay").click(function () {
  $("#weddingDateSelector").hide();
});  

function toggleAttribute() {
  $('.pdp-productForm-variants').each(function () {
    var $dropdown = $(this);
    $("div[id*='stone'] .ProductForm__Item", $dropdown).on("click", function (e) { /* RC-204 class name update - bugfix */
      e.preventDefault();
      $div = $(this, $dropdown);
      $('body.template-product').toggleClass("noscroll");
      if ($("body.template-product").hasClass('noscroll')) {
        $(this).removeClass('noscroll');
      }
      return false;
    });
  });
  $(document).on('click', function (e) { //Clicking outside the dropdown should remove the noscroll class
    var $dropdown = $(e.target).closest('.pdp-productForm-variants');
    if (!$dropdown.length) {
      $('body.template-product').removeClass("noscroll");
      $('div[id*="stone"] .ProductForm__Item').attr("aria-expanded", "false")
    }
  });
  $(".Popover__ValueList").delegate(".Popover__Value", "click", function () { //change attribute to false, once dropdown was closed
    $('div[id*="stone"] .ProductForm__Item').attr("aria-expanded", "false")
  });
  $(".Popover__Header").delegate(".Popover__Close", "click", function () { //change attribute to false, once popup close button was clicked - Mobile
    $('div[id*="stone"] .ProductForm__Item').attr("aria-expanded", "false")
  });
}

$(document).ajaxComplete(function () {
  toggleAttribute();  
});
$(window).on("load", function () {
  toggleAttribute(); 
});

var modal = document.getElementById('social-share');
var closebtn = document.getElementById('close-modal-button');
function shareModalOpen() {
  modal.style.display = "block";
}
$('.closeModal').click(function () {
  modal.style.display = "none";
})
var $temp = $("<input>");
var message = "Link Copied"
$('.copy_link').on('click', function () {
  var $url = $(location).attr('href');
  $("body").append($temp);
  $temp.val($url).select();
  document.execCommand("copy");
  $temp.remove();
  showErrorMessage(message)
})

function socialWindow(url) {
  var left = (screen.width - 570) / 2;
  var top = (screen.height - 570) / 2;
  var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
  window.open(url, "NewWindow", params);
}

$(".email_share").on("click", function () {
  var pageUrl = encodeURIComponent(document.URL);
  var url = `https://mail.google.com/mail/?view=cm&ui=2&tf=0&fs=1&to=&su=Exactly what I want…&body=The style I love from Ring Concierge! I promise I’ll act surprised.%0A%0A${pageUrl}`;
  socialWindow(url);
});

const mobileShareButton = document.querySelector('.mobile-share-button');
if (mobileShareButton) {
  mobileShareButton.addEventListener('click', event => {
    var product_name = location.pathname.split("/")[2].split('-').join(' ').toUpperCase()
    if (navigator.share) {
      navigator.share({
        title: 'Exactly what I want…',
        text: 'The style I love from Ring Concierge! I promise I’ll act surprised.\n\n',
        url: window.location.href
      }).then(() => {
        console.log('Thanks for sharing!');
      }).catch(err => {
        console.log("Error while using Web share API:");
        console.log(err);
      });
    } else {
      alert("Browser doesn't support this API !");
    }
  });
}

/* Dynamic Estimated Lead time Implementation : PDP */
var grabDynamicShippingDate = '';
async function getDynamicShippingDate() {
  try {
    // Fetch New York time zone
    const newYorkTimeZone = Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    });
    // Get the current time in New York time zone
    const newYorkTime = newYorkTimeZone.format(new Date());
    // shipping speed change to '2day' for 2-day shipping
    let shippingSpeed = dynamicEstimatedLeadTime || 'overnight';
    // set shipping label to overnight if not overnight or 2day
    if (shippingSpeed !== 'overnight' && shippingSpeed !== '2day') {
      shippingSpeed = 'overnight';
    }
    // Extract the hour and minute from the New York time
    const [hour, minute] = newYorkTime.split(':').map(part => parseInt(part));
    // Check if the current time is after the specified time (3:00 PM)
    const checkTimeAfter3PM = hour > 15 || (hour === 15 && minute > 0);
    // Check if the current day is a weekend (Sunday: 0, Saturday: 6)
    const dayOfWeek = new Date().getUTCDay();
    // Create a Date object for the current date
    const currentDate = new Date();
    // Calculate the estimated shipping date
    let estimatedShippingDate = new Date(currentDate);
    let estimatedShippingDateForDay = new Date(currentDate);
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      // If it's a weekend, move to Monday
      estimatedShippingDate.setDate(currentDate.getDate() + (1 + 7 - dayOfWeek));
    } else if (checkTimeAfter3PM) {
      // If it's after 3 PM, move to the next day
      estimatedShippingDate.setDate(currentDate.getDate() + 1);
    }
    // Adjust for shipping speed
    if (shippingSpeed === 'overnight') {
      estimatedShippingDate.setDate(currentDate.getDate() + 1);
    } else if (shippingSpeed === '2day') {
      estimatedShippingDate.setDate(currentDate.getDate() + 2);
    }
    // Check for weekends and move the date to Monday
    const estDayOfWeek = estimatedShippingDateForDay.getUTCDay();
    if (estDayOfWeek === 0) {
      estimatedShippingDate.setDate(estimatedShippingDate.getDate() + 1);
      if (shippingSpeed === '2day') estimatedShippingDate.setDate(estimatedShippingDate.getDate() + 1);
    } else if (estDayOfWeek === 6 || estDayOfWeek === 5 || estDayOfWeek === 4) {
      estimatedShippingDate.setDate(estimatedShippingDate.getDate() + 2);
    }
    // Format the estimated shipping date (Month/Day)
    const formattedShippingDate = `${estimatedShippingDate.getUTCMonth() + 1}/${estimatedShippingDate.getUTCDate()}`;
    const dynamicShippingDate = `${dynamicEstimatedPrefixText} ${formattedShippingDate} ${dynamicEstimatedSuffixText}`
    return dynamicShippingDate;
  } catch (error) {
    console.error("An error occurred:", error);
    return null; 
  }
}

if (dynamicEstimatedLeadTime != 'turnoff'){
  $.get("https://get.geojs.io/v1/ip/geo.json", function (response) {
    var visitorCountry = response.country;
    var visitorCountryCode = response.country_code;
    if ((visitorCountry && visitorCountry.toUpperCase() === 'UNITED STATES') || (visitorCountryCode && visitorCountryCode.toUpperCase() === 'US')) {
      getDynamicShippingDate()
      .then(finalData => {
        grabDynamicShippingDate = finalData
      });
    }
  })
}  

/** ==== Stock Level APP Messaging ==== **/
/* Close Lead time popup */
function stockLevelWarningPopupClose() {
  jQuery("#stockLevelWarningPopup").hide()
  jQuery(".ProductForm__AddToCart").html('Add to bag'); // RC-36 Final sale popup text change from Add to cart to Add to bag
  enableAddToCartButton();
}

function setFontFamilyToPreview(variant) {
  var vals1 = getOptionsVals(variant, 'Engraving Font')
  previewCharacters(vals1)
}

var getSelectedVariantData = '';
function grabSelectedVariant(variant) {
  getSelectedVariantData = variant;
}

/** Global Variable to Grab API Response Data **/
var grabToiMoiAPIResponseData = {};
/** Toi-et-moi View Combination **/
function previewColorCombination() {
  if (grabToiMoiAPIResponseData.data.length > 0) {
    $('.setErrorMessageTOI').addClass('hide')
    showProductInformation(grabToiMoiAPIResponseData);
  } else {
    $('.setErrorMessageTOI').removeClass('hide')
  }
}

/* ==== Open Preview Modal Popup ==== */
function showProductInformation(response) {
  var productId = currentProductJson.id
  $(".loader__section").removeClass("hide")
  $(".modal-window-content").addClass("hide")
  var divId = "MobSlider" + productId
  var imagesArr = response.data
  var imgCount = 0
  var images = '<div id="' + divId + '" class="carousel kit-carousel-popup ' + divId + '" data-flickity=`{ "pageDots": true, "imagesLoaded": true, "percentPosition": true, "fullscreen": true, "lazyLoad": true }`>'
  imagesArr.map((img, k) => {
    if (img && img !== '') {
      imgCount++
      images += `<img src="` + img + `" class="Image--fadeIn Image--lazyLoaded" style="object-fit: cover;"/>`;
    }
  })
  images += `</div>`;
  var productsHtml = `<section class="">
    <div class="pdp-toi-moi-slider">
    <div class="" id="productDetails`+ productId + `">
      `+ images + `
    </div>
    </div>
    </section>`;
  $("#product_info").find(".modal-window-content").html(productsHtml)
  var setObj = { pageDots: true, imagesLoaded: true, lazyLoad: true, bgLazyLoad: true }
  if (imgCount <= 1) {
    setObj.pageDots = false
  }
  $("#product_info").addClass("open");
  setTimeout(() => {
    $(".loader__section").addClass("hide")
    $(".modal-window-content").removeClass("hide")
    if ($("." + divId).length && $("." + divId).hasClass("flickity-enabled")) {
      $("." + divId).flickity('destroy');
    }
    $("." + divId).flickity(setObj);
  }, 500)
}

/** Preview Color Combination **/
function previewColorCombinationButton(productName) {
  var firstSelectedVariant, secondSelectedVariant, metalSelected, grabLetter, finalCombination;
  switch (productName) {
    case "_toi_moi_image":
      firstSelectedVariant = getPropertyValue('Emerald-Stone');
      secondSelectedVariant = getPropertyValue('Pear-Stone');
      break;
    case "_zodiac_image":
      firstSelectedVariant = getPropertyValue('zodiac_one');
      secondSelectedVariant = getPropertyValue('zodiac_two');
      break;
    case "_engraving_image":
      firstSelectedVariant = getPropertyValue('Engraving_Font');
      secondSelectedVariant = getPropertyValue('_engravingplacement');
      break;
    case "_signet_ring":
      firstSelectedVariant = getPropertyValue('Engraving_Font');
      break;  
    default:
      return;
  }
  var grabMetalValue = getOptionsVals(getSelectedVariantData, 'Metal')
  if (grabMetalValue !== 0) metalSelected = grabMetalValue.toLowerCase();
  if (currentProductJson.id === 7973256822872) secondSelectedVariant = 'duo';
  if (currentProductJson.id === 7973232869464) secondSelectedVariant = 'pave';
  if (firstSelectedVariant && secondSelectedVariant && metalSelected) {
    switch (true) {
      case metalSelected.includes('yellow'):
        grabLetter = 'y';
        break;
      case metalSelected.includes('rose'):
        grabLetter = 'r';
        break;
      case metalSelected.includes('white'):
        grabLetter = 'w';
        break;
      default:
        return;
    }
    if (productName === "_engraving_image") {
      var productTitle = '';
      if (currentProductJson.title.toLowerCase().includes("round")) productTitle = 'round';
      if (currentProductJson.title.toLowerCase().includes("rectangle")) productTitle = 'rectangle';
      finalCombination = `${grabLetter}-${productTitle}-${firstSelectedVariant}-${secondSelectedVariant}`.toLowerCase();
    } else {
      finalCombination = `${grabLetter}-${firstSelectedVariant}-${secondSelectedVariant}`.toLowerCase();
    }
    finalCombination = finalCombination.replaceAll(" ", "-").replace(/[()]/g, "");
    callToiMoiAPI(finalCombination, productName);
  }
}

/* Common Function to grab property value */
function getPropertyValue(propertyName) {
  return $(`input[name='properties[${propertyName}]']`).val();
}

/** API Call for Combination Images for Preview **/
async function callCombinationImagesAPI(finalCombination) {
  try {
    var response = await fetch(`${portalApiUrl}/color_combination/${finalCombination}`);
    if (response.ok) {
      var data = await response.json();
      return data;
    } else {
      throw new Error('Request failed with status ' + response.status);
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

/** API Call for TOI-AT-MOI Preview Combination **/
async function callToiMoiAPI(finalCombination, productName) {
  productName = productName.replace(/['"]+/g, '')
  var response = await callCombinationImagesAPI(finalCombination);
  if (response.data.length > 0 && response.status === true) {
    selectedVariantImage(response.data[0]);
    if ($("input[name='properties[" + productName + "]']").length !== 0) {
      $('form[action="/cart/add"]').find("input[name='properties[" + productName + "]']").val(response.data[0]);
    } else {
      $('form[action="/cart/add"]').append('<input type="hidden" name="properties[' + productName + ']" value= "' + response.data[0] + '" />');
    }
    grabToiMoiAPIResponseData = response;
    $(".pdp-product-gallery-wrapper").find(".flickity-slider:first img:first").attr("srcset", response.data[0]);
    var imgSource = $(".pdp-product-gallery-wrapper").find(".flickity-slider").eq(0).first().find("img").attr("srcset");
    $(".pdp-product-gallery-wrapper").find(".flickity-slider").eq(1).find(".carousel-cell").first().find("img").attr("data-src", imgSource).attr("src", imgSource);
    $(".pdp-product-gallery-wrapper").find(".flickity-slider").eq(0).first().find("img").click(function () {
      setTimeout(function () {
        $(".pswp__zoom-wrap").find("img").eq(1).attr("src", imgSource);
      }, 630);
    })
    $(".pdp-product-gallery-wrapper").find(".flickity-slider").eq(0).first().find(".Product__SlideItem").removeClass("is-selected").first().addClass("is-selected");
  } else {
    $('#viewColorCombination').addClass('hide')
  }
  if (response && response.status == false && productName) {
    var img;
    if (productName === "_toi_moi_image") {
      switch (finalCombination.charAt(0)) {
        case 'r': img = toiMoiRoseImage;
          break;
        case 'w': img = toiMoiWhiteImage;
          break;
        default: img = toiMoiYellowImage;
          break;
      }
    }
    if (productName === "_zodiac_image") {
      switch (finalCombination.charAt(0)) {
        case 'w': img = zodiacWhiteImage;
          break;
        default: img = zodiacYellowImage;
          break;
      }
    }
    selectedVariantImage(img);
    $(".pdp-product-gallery-wrapper").find(".flickity-slider").eq(0).first().find("img").first().attr("srcset", img);
    if ($("input[name='properties[" + productName + "]']").length != 0) {
      $('form[action="/cart/add"]').find("input[name='properties[" + productName + "]']").val(img);
    } else {
      $('form[action="/cart/add"]').append('<input type="hidden" name="properties[' + productName + ']" value= "' + img + '" />');
    }
    $(".pdp-product-gallery-wrapper").find(".flickity-slider").eq(1).find(".carousel-cell").first().find("img").attr("data-src", img).attr("src", img);
    $(".pdp-product-gallery-wrapper").find(".flickity-slider").eq(0).first().find(".Product__SlideItem").removeClass("is-selected").first().addClass("is-selected");
    $(".pdp-product-gallery-wrapper").find(".flickity-slider").eq(0).first().find("img").click(function () {
      setTimeout(function () {
        $(".pswp__zoom-wrap").find("img").eq(1).attr("src", img);
      }, 630);
    })
  }
  if ($window.width() < 1007) {
    switchToSlideOne()
  }
}

/* Switch to first Slide */
function switchToSlideOne(){
  var flkty = Flickity.data($('.pdp-product-slideshow')[0]);
  if (flkty) {
    flkty.select(0);
  } else {
    console.error('Flickity instance not found.');
  }
}

if (currentProductJson && (currentProductJson.id === 7016921235544 || currentProductJson.id === 6644686127192 || 
                           currentProductJson.id === 7435379802200 || currentProductJson.id === 7502665908312 ||  
                           currentProductJson.id === 7435379507288 || currentProductJson.id === 7502659813464 || 
                           currentProductJson.id === 7973256822872 || currentProductJson.id === 7973232869464)) {
  $(".Popover__Value, .HorizontalList__Item").click(function () {
    setTimeout(function () {
      if (currentProductJson.id === 7016921235544) previewColorCombinationButton("_toi_moi_image");
      if (currentProductJson.id === 6644686127192) previewColorCombinationButton("_zodiac_image");
      if (currentProductJson.id === 7435379802200) previewColorCombinationButton("_engraving_image");
      if (currentProductJson.id === 7502665908312) previewColorCombinationButton("_engraving_image");
      if (currentProductJson.id === 7435379507288) previewColorCombinationButton("_engraving_image");
      if (currentProductJson.id === 7502659813464) previewColorCombinationButton("_engraving_image");
      if (currentProductJson.id === 7973256822872) previewColorCombinationButton("_signet_ring");
      if (currentProductJson.id === 7973232869464) previewColorCombinationButton("_signet_ring");
    }, 100);
  })
}

function toietmoiViewCombination() {
  $("#viewColorCombination").addClass("hide");
  $('.setErrorMessageTOI').addClass('hide')
}

function setLineItemPropAboveOneKPrice(variant) {
  var ifPropertyFieldIsPresent = $('form[action="/cart/add"]').find(`input[name="properties[_giftwrap]"]`).length;
  if (getVariantMetafieldValue(variant.id, "_giftwrap") === 'true' || getVariantMetafieldValue(variant.id, "_giftwrap") === true) {
    if (ifPropertyFieldIsPresent > 0) {
      $('form[action="/cart/add"]').find(`input[name="properties[_giftwrap]"]`).attr("value", "true")
    } else {
      var newInputElement = $('<input>', {
        type: 'hidden',  
        name: 'properties[_giftwrap]',  
        value: 'true'
      });
    }
  } else {
    if (ifPropertyFieldIsPresent > 0) {
      $('form[action="/cart/add"]').find(`input[name="properties[_giftwrap]"]`).remove();
    }
  }
}

async function getVariantSkuDetails(variant) {
  $('#appendSale').html('');
  $('#appendCompareAt').html('');
  $("#percentOff").html('');
  $('#priceAbbreviation').addClass('defaultHide');
  $(".ProductMeta__PriceList").html('').hide()
  $('#appendReg').removeClass("strikeThrough").css("color", "#000");
  var regular_price = fraction.format(variant.price/100);
  var compareAtPrice = isFinite(variant?.compare_at_price) ? parseFloat(variant.compare_at_price / 100) : 0;
  var variantPrice = isFinite(variant?.price) ? parseFloat(variant.price / 100) : 0;
  var vipPrice = getVariantMetafieldValue(variant.id, 'vip_price') && isFinite(getVariantMetafieldValue(variant.id, 'vip_price')?.amount) ? parseFloat(getVariantMetafieldValue(variant.id, 'vip_price').amount) : 0;
  var vvipPrice = getVariantMetafieldValue(variant.id, 'vvip_price') && isFinite(getVariantMetafieldValue(variant.id, 'vvip_price')?.amount) ? parseFloat(getVariantMetafieldValue(variant.id, 'vvip_price').amount) : 0;
  var checkVisitingCustomer = localStorage.getItem("setVisitingCustomer");
  var checkVisitingCustomerPrivateSale = localStorage.getItem("setVisitingCustomerPrivateSale");
  
  var salePrice = 0;
  var showPercentOff = false;

  var ogVariantPrice = variantPrice;
  var ogSalePrice = salePrice;
  var ogCompareAtPrice = compareAtPrice;

  /* Sale Price for All Visitors */
  if (showSalePriceGlobal && showSalePriceGlobal === true) {
    salePrice = getVariantMetafieldValue(variant.id, 'sale_price') ? parseFloat(getVariantMetafieldValue(variant.id, 'sale_price').amount) : 0;
    ogSalePrice = salePrice;
    showPercentOff = true;
  }
  /* Sale Price to show for VIP Visitors */
  if (showVIPPriceGlobal && showVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVIPParam) {
    salePrice = vipPrice;
    ogSalePrice = salePrice;
    showPercentOff = true;
  }
  /* Sale Price to show for VVIP Visitors */
  if (showVVIPPriceGlobal && showVVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVVIPParam) {
    salePrice = vvipPrice;
    ogSalePrice = salePrice;
    showPercentOff = true;
  }
  /* Locked Private Sale: Sale Price to show for VIP Visitors */
  if (showVIPPrivateSale && showVIPPrivateSale === true && checkVIPUser && checkVIPUser === true && checkVisitingCustomerPrivateSale && checkVisitingCustomerPrivateSale === getVIPParamPrivateSale) {
    salePrice = vipPrice;
    ogSalePrice = salePrice;
    showPercentOff = true;
  }
  /* Locked Private Sale: Sale Price to show for VVIP Visitors */
  if (showVVIPPrivateSale && showVVIPPrivateSale === true && checkVVIPUser && checkVVIPUser === true && checkVisitingCustomerPrivateSale && checkVisitingCustomerPrivateSale === getVVIPParamPrivateSale) {
    salePrice = vvipPrice;
    ogSalePrice = salePrice;
    showPercentOff = true;
  }

  var engravablesInputCheck = $("#engravablesInputsWrapper").prop("checked");
  if($("#engravablesInputsWrapper").length !== 0){
    if(engravablesInputCheck == true) {
      variantPrice = variantPrice + engravingProductPrice;
      if(salePrice !== 0) salePrice = salePrice + engravingProductPrice;
      if(compareAtPrice !== 0) compareAtPrice = compareAtPrice + engravingProductPrice;
    }
  }

  var formattedSalePrice = salePrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  formattedSalePrice = formatPriceFunc(formattedSalePrice);  /* Code to remove decimal if .00 found in the price */
  var formattedCompareAtPrice = compareAtPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  formattedCompareAtPrice = formatPriceFunc(formattedCompareAtPrice);  /* Code to remove decimal if .00 found in the price */
  var formattedVariantPrice = variantPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  formattedVariantPrice = formatPriceFunc(formattedVariantPrice);  /* Code to remove decimal if .00 found in the price */

  var formatWithoutSalePrice = variantPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  formatWithoutSalePrice = formatPriceFunc(formatWithoutSalePrice);

  var percentageOff = ''
  if (showPercentOff == true) {
    // We do not want to include engraving price to calculate the percent off, that is why we remove the engraving price from the main variant price and sale price
    if($("#engravablesInputsWrapper").length !== 0){
      if(engravablesInputCheck == true) {
        variantPrice = variantPrice - engravingProductPrice;
        salePrice = salePrice - engravingProductPrice;
      }
    }
    percentageOff = (((ogVariantPrice - ogSalePrice) / ogVariantPrice) * 100).toFixed(2)
    percentageOff = formatPriceFunc(percentageOff);
    percentageOff = percentageOff + "% Off";
  }
  if (ogCompareAtPrice && ogCompareAtPrice != null && ogCompareAtPrice > 0 && ogCompareAtPrice > ogVariantPrice) {
    percentageOff = (((ogCompareAtPrice - ogVariantPrice) / ogCompareAtPrice) * 100).toFixed(2)
    percentageOff = percentageOff.replace(/\.00$/, '') + "% Off";
  }
  
  if ((salePrice != '' && salePrice > 0 && salePrice < variantPrice) || (compareAtPrice != null && compareAtPrice > 0)) {
    if (compareAtPrice && compareAtPrice > parseFloat(variantPrice)) {
      $('#appendReg').html("$" + formattedVariantPrice).removeClass("strikeThrough").css("color", salePriceColorGlobal);
      $('#appendCompareAt').html("$" + formattedCompareAtPrice).addClass("strikeThrough");
      $(".percentageCompareAt").remove();
      if ($(`.${variant.id}_percentOff`).length === 0){
        $('#appendCompareAt').after('<span id="percentOff" class="percentageCompareAt ' + variant.id + '_percentOff" style=color:' + showPercentageOffColorGlobal + '> ' + percentageOff + '</span>')
      }
      // $('#priceAbbreviation').removeClass('defaultHide'); /* Hiding Price Abbreviation(Was) */
      $('#managePricing').addClass('manage-price-font');  
    } else {
      if (salePrice && parseFloat(salePrice) < parseFloat(variantPrice)) {
        $('#appendReg').html("$" + formattedVariantPrice).addClass("strikeThrough");
        $('#appendReg').after('<span id="percentOff" class="percentageOffPDP" style=color:' + showPercentageOffColorGlobal + '> ' + percentageOff + '</span>')
        $('#appendSale').html("$" + formattedSalePrice).css("color", salePriceColorGlobal);
      }
    }
  } else {
    $('#appendReg').html("$" + formattedVariantPrice).removeClass("strikeThrough").css({"color": "#000","font-size": "25px"});
  }
}

function stockLevelWarningPopupOkButton() {
  stockLevelWarningPopupClose()
  var defaultFormData = jQuery('form[action="/cart/add"]').serializeObject()
}

function findRequiredFields(cb) {
  var addToCartForm = jQuery(".ProductForm__AddToCart").closest('form[action="/cart/add"]')
  var requiredElem = jQuery(addToCartForm).find("*[data-required='true']")
  var validateElem = []
  var noneValidateElem = []
  jQuery('.errormsg').removeClass('open').addClass('hide')
  var miniHeart1 = jQuery('#customMiniHeartWrapper').find('input[name="properties[Mini Heart 1]"]').val()
  var miniHeart2 = jQuery('#customMiniHeartWrapper').find('input[name="properties[Mini Heart 2]"]').val()
  var miniHeart3 = jQuery('#customMiniHeartWrapper').find('input[name="properties[Mini Heart 3]"]').val()
  var miniHeart4 = jQuery('#customMiniHeartWrapper').find('input[name="properties[Mini Heart 4]"]').val()
  var miniHeart5 = jQuery('#customMiniHeartWrapper').find('input[name="properties[Mini Heart 5]"]').val()
  var colorDropTitle = jQuery('#color-dropdown').find('input[name="properties[Color]"]').val()
  var pearStoneTitle = jQuery('#pearstoneWrapper').find('input[name="properties[Pear-Stone]"]').val()
  var emeraldStoneTitle = jQuery('#emeraldstoneWrapper').find('input[name="properties[Emerald-Stone]"]').val()
  var zodiacOneValue = jQuery('#zodiacOneWrapper').find('input[name="properties[zodiac_one]"]').val()
  var zodiacTwoValue = jQuery('#zodiacTwoWrapper').find('input[name="properties[zodiac_two]"]').val()
  var engravableFontSelect = jQuery('#engravable').find('input[name="properties[Engraving_Font]"]').val()
  var engravableFontTwoSelect = $('input[name="properties[Engraving_Font_2]"]').val();
  var engravablePlacementSelect = jQuery('#engravingPlacement').val()
  var engravableText = jQuery('#engravable').find('input[name="properties[Engraving_Text]"]').val()
  var engravableTextTwo = jQuery('#engravingTextTwo').find('input[name="properties[Engraving_Text_2]"]').val()
  var engravableTextSpaceCheck = !/\S/.test(engravableText) // Checking if the input value contains only white spaces or not (Output in Boolean : true/false)
  var engraveToggle = jQuery('#engravablesInputsWrapper').is(":checked")
  var checkEngravingProduct = currentProductJson ? currentProductJson.tags.filter(s => s.includes('Engravable')) : [];
  var checkEngravingSideOptions = currentProductJson ? currentProductJson.tags.filter(s => s.includes('engraving-side-options')) : [];
  var isSelectAnyEngraving = currentProductJson ? currentProductJson.tags.filter(s => s.includes('engravable-select-any')) : [];
  var mensDropTitle = jQuery('#menssizeWrapper').find('input[name="properties[Size]"]').val()
  var womensDropTitle = jQuery('#womenssizeWrapper').find('input[name="properties[Size]"]').val()
  var customSizeTitle = jQuery('#customSizeWrapper').find('input[name="properties[Size]"]').val()
  var nameRequired = false
  var Heart1 = jQuery('#customHeartWrapper').find('input[name="properties[Large Heart Text]"]').val()
  var Heart2 = jQuery('#customHeartWrapper').find('input[name="properties[First Mini Heart Text]"]').val()
  var Heart3 = jQuery('#customHeartWrapper').find('input[name="properties[Second Mini Heart Text]"]').val()
  var Heart4 = jQuery('#customHeartWrapper').find('input[name="properties[Third Mini Heart Text]"]').val()
  var Heart5 = jQuery('#customHeartWrapper').find('input[name="properties[Fourth Mini Heart Text]"]').val()
  var compNote = jQuery('#complimentary_Note').find('textarea').val()
  var customization = jQuery('#customization').val()
  var stone1 = jQuery('#custom-stones').find('input[name="properties[_Custom_Stone_Title_1]"]').val()
  var stone2 = jQuery('#custom-stones').find('input[name="properties[_Custom_Stone_Title_2]"]').val()
  var stone3 = jQuery('#custom-stones').find('input[name="properties[_Custom_Stone_Title_3]"]').val()
  var stone4 = jQuery('#custom-stones').find('input[name="properties[_Custom_Stone_Title_4]"]').val()
  var stone5 = jQuery('#custom-stones').find('input[name="properties[_Custom_Stone_Title_5]"]').val()
  var lockerCharmProduct = currentProductJson ? currentProductJson.tags.filter(s => s.includes('locket-charms')) : [];
  var status = true;
  var sideOptionEngravingTextOne = false;
  var sideOptionEngravingFontOne = false;
  var sideOptionEngravingTextTwo = false;
  var sideOptionEngravingFontTwo = false;

  if (jQuery('#customMiniHeartWrapper').length &&
    (!miniHeart1 && `${miniHeart1}`.length === 0 ||
      !miniHeart2 && `${miniHeart2}`.length === 0 ||
      !miniHeart3 && `${miniHeart3}`.length === 0 ||
      !miniHeart4 && `${miniHeart4}`.length === 0 ||
      !miniHeart5 && `${miniHeart5}`.length === 0)) {
    jQuery('.mini-heart-error').text('Engraving required to add item to cart.').removeClass('hide').addClass('open') 
    jQuery('#customMiniHeartWrapper').addClass('required') 
    status = false
  } else if (status &&
    (!miniHeart1 && `${miniHeart1}`.length !== 0 ||
      !miniHeart2 && `${miniHeart2}`.length !== 0 ||
      !miniHeart3 && `${miniHeart3}`.length !== 0 ||
      !miniHeart4 && `${miniHeart4}`.length !== 0 ||
      !miniHeart5 && `${miniHeart5}`.length !== 0)) {
    jQuery('.mini-heart-error').text('').removeClass('open').addClass('hide') 
    jQuery('#customMiniHeartWrapper').removeClass('required') 
    status = true
  }
  if (status && jQuery('#customHeartWrapper').length && (
    !Heart1 && `${Heart1}`.length === 0 ||
    !Heart2 && `${Heart2}`.length === 0 ||
    !Heart3 && `${Heart3}`.length === 0 ||
    !Heart4 && `${Heart4}`.length === 0 ||
    !Heart5 && `${Heart5}`.length === 0)) {
    jQuery('.heart-wrap-error').text('Engraving required to add item to cart.').removeClass('hide').addClass('open') 
    jQuery('#customHeartWrapper').addClass('required')  
    status = false
  } else if (status && (!Heart1 && `${Heart1}`.length !== 0 ||
    !Heart2 && `${Heart2}`.length !== 0 ||
    !Heart3 && `${Heart3}`.length !== 0 ||
    !Heart4 && `${Heart4}`.length !== 0 ||
    !Heart5 && `${Heart5}`.length !== 0)) {
    jQuery('.heart-wrap-error').text('').removeClass('open').addClass('hide') 
    jQuery('#customHeartWrapper').removeClass('required') 
    status = true
  }

  if (status && jQuery('#color-dropdown').length && !colorDropTitle && `${colorDropTitle}`.length === 0) {
    jQuery('.color-error').text('Please select color to proceed to cart.').removeClass('hide').addClass('open') 
    jQuery('#color-dropdown').addClass('required') 
    status = false
  } else if (status && colorDropTitle && `${colorDropTitle}`.length !== 0) {
    jQuery('.color-error').text('').removeClass('open').addClass('hide')
    jQuery('#color-dropdown').removeClass('required')
    status = true
  }

  if (status && jQuery('#custom-stones').length && (
    !stone1 && `${stone1}`.length === 0 ||
    !stone2 && `${stone2}`.length === 0 ||
    !stone3 && `${stone3}`.length === 0 ||
    !stone4 && `${stone4}`.length === 0 ||
    !stone5 && `${stone5}`.length === 0)) {

    jQuery('.stone-error').text(lockerCharmProduct.length ? 'Charms required to add item to cart.' : 'Stones required to add item to cart.').removeClass('hide').addClass('open');
    jQuery('#custom-stones .ProductForm__Option').addClass('required'); 
    status = false
  } else if (status && (!stone1 && `${stone1}`.length !== 0 ||
    !stone2 && `${stone2}`.length !== 0 ||
    !stone3 && `${stone3}`.length !== 0 ||
    !stone4 && `${stone4}`.length !== 0 ||
    !stone5 && `${stone5}`.length !== 0)) {
    jQuery('.stone-error').text('').removeClass('open').addClass('hide'); 
    jQuery('#custom-stones .ProductForm__Option').removeClass('required'); 
    status = true
  }

  if (status && jQuery('#complimentarywrapCheckbox').is(':checked') && !compNote && `${compNote}`.length === 0) {
    jQuery('.errormsg').text('Please enter a Complimentry message to proceed to cart.').removeClass('hide').addClass('open')
    jQuery('#complimentary_Note').find('textarea').addClass('required')
    status = false
  } else if (status && compNote && `${compNote}`.length !== 0) {
    jQuery('#complimentary_Note').find('textarea').removeClass('required')
    jQuery('.errormsg').text('').removeClass('open').addClass('hide')
    status = true
  }

  if (status && jQuery('#emeraldstoneWrapper').length && !emeraldStoneTitle && `${emeraldStoneTitle}`.length === 0) {
    jQuery('.emeraldstone-error').text('Please select Emerald stone to proceed to cart.').removeClass('hide').addClass('open')
    jQuery('#emeraldstoneWrapper').addClass('required')
    status = false
  } else if (status && emeraldStoneTitle && `${emeraldStoneTitle}`.length !== 0) {
    jQuery('.emeraldstone-error').text('').removeClass('open').addClass('hide') 
    jQuery('#emeraldstoneWrapper').removeClass('required') 
    status = true
  }

  if (status && jQuery('#zodiacOneWrapper').length && !zodiacOneValue && `${zodiacOneValue}`.length === 0) {
    jQuery('.zodiac-one-error').text('Please select Zodiac One to proceed to cart.').removeClass('hide').addClass('open')
    jQuery('#zodiacOneWrapper').addClass('required')
    status = false
  } else if (status && zodiacOneValue && `${zodiacOneValue}`.length !== 0) {
    jQuery('.zodiac-one-error').text('').removeClass('open').addClass('hide')
    jQuery('#zodiacOneWrapper').removeClass('required')
    status = true
  }

  if (status && jQuery('#zodiacTwoWrapper').length && !zodiacTwoValue && `${zodiacTwoValue}`.length === 0) {
    jQuery('.zodiac-two-error').text('Please select Zodiac Two to proceed to cart.').removeClass('hide').addClass('open')
    jQuery('#zodiacTwoWrapper').addClass('required')
    status = false
  } else if (status && zodiacTwoValue && `${zodiacTwoValue}`.length !== 0) {
    jQuery('.zodiac-two-error').text('').removeClass('open').addClass('hide')
    jQuery('#zodiacTwoWrapper').removeClass('required')
    status = true
  }

  if (status && checkEngravingProduct && checkEngravingProduct.length != 0 && !checkEngravingSideOptions.length) {
    if (engraveToggle == true) {
      if (status && jQuery('#engravable').length && !engravableFontSelect && `${engravableFontSelect}`.length === 0 && engraveToggle == true) {
        $("#weddingDateSelector").hide();
        jQuery('.engravable-error').text('Please select Engraving Font to proceed to cart.').removeClass('hide').addClass('open')
        jQuery('#engravable').addClass('required')
        jQuery('#input-text-engraving-styles').addClass('required')
        status = false
      } else if (status && engravableFontSelect && `${engravableFontSelect}`.length !== 0) {
        jQuery('.engravable-error').text('').removeClass('open').addClass('hide')
        jQuery('#engravable').removeClass('required')
        jQuery('#input-text-engraving-styles').removeClass('required')
        status = true
      }
      
      if(status && jQuery('#engravable_placement').length && !engravablePlacementSelect && `${engravablePlacementSelect}`.length === 0 && engraveToggle == true){
        jQuery('.engravable-placement-error').text('Please select Engraving Placement to proceed to cart.').removeClass('hide').addClass('open')
        jQuery('#engravable_placement').addClass('required')
        jQuery('#input-text-engraving-styles').addClass('required')
        status = false
      } else if (status && engravablePlacementSelect && `${engravablePlacementSelect}`.length !== 0){
        jQuery('.engravable-placement-error').text('').removeClass('open').addClass('hide')
        jQuery('#engravable_placement').removeClass('required')
        jQuery('#input-text-engraving-styles').removeClass('required')
        status = true
      }

      if (status && jQuery('#engravable').length && engravableTextSpaceCheck && engraveToggle == true && !isSelectAnyEngraving.length) {
        jQuery('.engravable-text-error').text('Please enter Customization text to proceed to cart.').removeClass('hide').addClass('open')
        jQuery('#engravable').addClass('required')
        jQuery('#input-text-engraving-styles').addClass('required')
        status = false
      } else if (status && engravableText && `${engravableText}`.length !== 0) {
        jQuery('.engravable-text-error').text('').removeClass('open').addClass('hide')
        jQuery('#engravable').removeClass('required')
        jQuery('#input-text-engraving-styles').removeClass('required')
        status = true
      }

      if ($('#engravable').length && engraveToggle == true && isSelectAnyEngraving.length) {
        if($('#input-text-engraving-styles').val().length || $('#input-text-engraving-styles-optional').val().length || $('#input-text-engraving-styles-optional-three').val().length) {
           jQuery('.engravable-text-error-is-any').text('').removeClass('open').addClass('hide')
           jQuery('#engravable').removeClass('required')
           jQuery('#input-text-engraving-styles').removeClass('required')
           status = true
        } else {
          jQuery('.engravable-text-error-is-any').text('Please enter Customization text to proceed to cart.').removeClass('hide').addClass('open')
          jQuery('#engravable').addClass('required')
          jQuery('#input-text-engraving-styles').addClass('required')
          status = false
        }
      }
      
      /* For Customization text two */
      if($('.engravable-placement-title').text() !== ('Center')){
        if (status && jQuery('#engravingTextTwo').length && jQuery('#engravable_placement_dropdown_input_box').val().length === 0  && engraveToggle == true) {
          jQuery('.engravable-text-two-error').text('The second line of text is required for this placement.').removeClass('hide').addClass('open')
          jQuery('#engravingTextTwo').addClass('required')
          jQuery('#engravable_placement_dropdown_input_box').addClass('required')
          status = false
        } else if (status && jQuery('#engravable_placement_dropdown_input_box').val().length !== 0) {
          jQuery('.engravable-text-two-error').text('').removeClass('open').addClass('hide')
          jQuery('#engravingTextTwo').removeClass('required')
          jQuery('#engravable_placement_dropdown_input_box').removeClass('required')
          status = true
        } 
      }
    } else {
      jQuery('.engravable-text-error').text('').removeClass('open').addClass('hide')
      jQuery('#engravable').removeClass('required')
      jQuery('#input-text-engraving-styles').removeClass('required')
      status = true
    }
  }

  if (status && checkEngravingProduct && checkEngravingProduct.length && checkEngravingSideOptions.length) {
    if (engraveToggle == true) {

      let textTwoValid = true;

      // ---- Determine fill state of both font fields ----
      const sideOneFilled = engravableFontSelect && `${engravableFontSelect}`.length !== 0;
      const sideTwoFilled = engravableFontTwoSelect && `${engravableFontTwoSelect}`.length !== 0;
      const eitherFontFilled = sideOneFilled || sideTwoFilled;

      // ---- Side One / Side Two: OR logic (at least one font must be selected) ----
      if (!eitherFontFilled) {
        if ($('#engravable').length) {
          $("#weddingDateSelector").hide();
          $('.engravable-error').text('Please select Engraving Font to proceed to cart.').removeClass('hide').addClass('open');
          $('#engravable').addClass('required');
          $('#input-text-engraving-styles').addClass('required');
        }
        if ($('#engravable_two').length) {
          $('.engravable-font-two-error').text('Please select Engraving Font to proceed to cart.').removeClass('hide').addClass('open');
          $('#engravable_two').addClass('required');
        }
      } else {
        $('.engravable-error').text('').removeClass('open').addClass('hide');
        $('#engravable').removeClass('required');
        $('#input-text-engraving-styles').removeClass('required');

        $('.engravable-font-two-error').text('').removeClass('open').addClass('hide');
        $('#engravable_two').removeClass('required');
      }

      // ---- Customization text-space check — only relevant when side one is in use ----
      if (sideOneFilled && $('#engravable').length && engravableTextSpaceCheck) {
        $('.engravable-text-error').text('Please enter Customization text to proceed to cart.').removeClass('hide').addClass('open');
        $('#engravable').addClass('required');
        $('#input-text-engraving-styles').addClass('required');
      } else {
        $('.engravable-text-error').text('').removeClass('open').addClass('hide');

        // only clear side-one-specific fields if side two is actually the one in use
        if (sideTwoFilled) {
          $('#engravingFont').removeClass('required').removeAttr('data-required');
          $('#engravingText').removeClass('required').removeAttr('data-required');
        }
      }

      // ---- Second line text / placement dropdown — only relevant when side two is in use ----
      if (sideTwoFilled && $('#engravingTextTwo').length) {
        if ($('#engravable_placement_dropdown_input_box').val().length === 0) {
          $('.engravable-text-two-error').text('Please enter Customization text to proceed to cart.').removeClass('hide').addClass('open');
          $('#engravingTextTwo').addClass('required');
          $('#engravable_placement_dropdown_input_box').addClass('required');
          textTwoValid = false;
        } else {
          $('.engravable-text-two-error').text('').removeClass('open').addClass('hide');
          $('#engravingTextTwo').removeClass('required');
          $('#engravable_placement_dropdown_input_box').removeClass('required').removeAttr('data-required');
        }
      } else if (sideOneFilled) {
        // only clear side-two-specific fields if side one is actually the one in use
        $('.engravable-text-two-error').text('').removeClass('open').addClass('hide');
        $('#engravingTextTwo').removeClass('required');
        $('#engravable_placement_dropdown_input_box').removeClass('required').removeAttr('data-required');
        $('#engravingFontTwo').removeClass('required').removeAttr('data-required');
      }

      // ---- Final status ----
      status = status && eitherFontFilled && textTwoValid &&
              !(sideOneFilled && $('#engravable').length && engravableTextSpaceCheck);

    } else {
      $('.engravable-text-error').text('').removeClass('open').addClass('hide');
      $('#engravable').removeClass('required');
      $('#input-text-engraving-styles').removeClass('required');
      status = true;
    }
  }

  if (status && jQuery('#pearstoneWrapper').length && !pearStoneTitle && `${pearStoneTitle}`.length === 0) {
    jQuery('.pearstone-error').text('Please select Pear Stone to proceed to cart.').removeClass('hide').addClass('open')  
    jQuery('#pearstoneWrapper').addClass('required') 
    status = false
  } else if (status && pearStoneTitle && `${pearStoneTitle}`.length !== 0) {
    jQuery('.pearstone-error').text('').removeClass('open').addClass('hide') 
    jQuery('#pearstoneWrapper').removeClass('required') 
    status = true
  }

  if (status && jQuery('#menssizeWrapper').length && !mensDropTitle && `${mensDropTitle}`.length === 0) {
    jQuery('.menssize-error').text('Please select size to proceed to cart.').removeClass('hide').addClass('open') 
    jQuery('#menssizeWrapper').addClass('required') 
    status = false
  } else if (status && mensDropTitle && `${mensDropTitle}`.length !== 0) {
    jQuery('.menssize-error').text('').removeClass('open').addClass('hide') 
    jQuery('#menssizeWrapper').removeClass('required') 
    status = true
  }

  if (status && jQuery('#womenssizeWrapper').length && !womensDropTitle && `${womensDropTitle}`.length === 0) {
    jQuery('.womenssize-error').text('Please select size to proceed to cart.').removeClass('hide').addClass('open') 
    jQuery('#womenssizeWrapper').addClass('required') 
    status = false
  } else if (status && womensDropTitle && `${womensDropTitle}`.length !== 0) {
    jQuery('.womenssize-error').text('').removeClass('open').addClass('hide') 
    jQuery('#womenssizeWrapper').removeClass('required') 
    status = true
  }

  if (status && jQuery('#customSizeWrapper').length && !customSizeTitle && `${customSizeTitle}`.length === 0) {
    jQuery('.custom-size-error').text('Please select size to proceed to cart.').removeClass('hide').addClass('open')
    jQuery('#customSizeWrapper').addClass('required')
    status = false
  } else if (status && customSizeTitle && `${customSizeTitle}`.length !== 0) {
    jQuery('.custom-size-error').text('').removeClass('open').addClass('hide')
    jQuery('#customSizeWrapper').removeClass('required')
    status = true
  }

  if(status && $(".font-dropdown").length && !$("#fontName").val()){
    jQuery('.font-error').text('Please select font to proceed.').removeClass('hide').addClass('open') 
    status = false
  } else if(status && $(".font-dropdown").length && $("#fontName").val() !== ""){
    jQuery('.font-error').text('').removeClass('open').addClass('hide') 
    status = true
  }
  if (status && jQuery('#customization').length && !customization && `${customization}`.length === 0 && !currentProductJson.tags.includes('customization-optional') && jQuery('#customization').attr('Valid') === 'Yes') {
    jQuery('.customization-error').text('Please enter minimum character to proceed.').removeClass('hide').addClass('open') 
    status = false
  } else if (status && customization && `${customization}`.length !== 0) {
    jQuery('.customization-error').text('').removeClass('open').addClass('hide') 
    status = true
  }

  var engravableToggleMejuri = $('#engravablesInputsWrapperMejuri');
  if (engravableToggleMejuri.length && engravableToggleMejuri.is(":checked")) {
    var verifyCustomizationMejuriOne = $('#mejuriEngravingOne');
    var verifyCustomizationMejuriTwo = $('#mejuriEngravingTwo');
    var verifyEngravingPlacement = $('.custom-engraving-selector');
    var verifyEngravingFont = $('.custom-font-selector');
    var isDataRequiredOne = $('#mejuriEngravingOne').attr('data-required');
    var isDataRequiredTwo = $('#mejuriEngravingTwo').attr('data-required');
    
    if(verifyEngravingFont.length && verifyEngravingFont.val().trim() === '') {
      jQuery('.font-selector-mejuri-error').text('Please select engraving font.').removeClass('hide').addClass('open') 
      verifyEngravingFont.addClass('required')
      jQuery('.Cart__Checkout').attr('disabled', 'disabled')
      status = false
    }

    if(verifyEngravingPlacement.length && verifyEngravingPlacement.val().trim() === '') {
      jQuery('.placement-selector-mejuri-error').text('Please select engraving placement.').removeClass('hide').addClass('open') 
      verifyEngravingPlacement.addClass('required')
      jQuery('.Cart__Checkout').attr('disabled', 'disabled')
      status = false
    }

    if (verifyCustomizationMejuriOne.length && isDataRequiredOne === 'true' && verifyEngravingPlacement.length) {
      var engravingValue = verifyCustomizationMejuriOne.val();
      if (engravingValue.trim() === '') {
        jQuery('.custom-text-one-mejuri-error').text('Please enter minimum character to proceed.').removeClass('hide').addClass('open') 
        verifyCustomizationMejuriOne.addClass('required')
        jQuery('.Cart__Checkout').attr('disabled', 'disabled')
        status = false
      }
    }

    if (verifyCustomizationMejuriTwo.length && isDataRequiredTwo === 'true' && verifyEngravingPlacement.length && verifyEngravingPlacement.val().trim() !== 'Center') {
      var engravingValue = verifyCustomizationMejuriTwo.val();
      if (engravingValue.trim() === '') {
        jQuery('.custom-text-two-mejuri-error').text('Please enter minimum character to proceed.').removeClass('hide').addClass('open') 
        verifyCustomizationMejuriTwo.addClass('required')
        jQuery('.Cart__Checkout').attr('disabled', 'disabled')
        status = false
      }
    }
  }

  var verifyCustomization = jQuery('#customization');
  if (currentProductJson.options.includes('Letter Count') == true) {
    if (verifyCustomization && verifyCustomization.val()) {
      var response = verifyCustomization.attr('maxlength')
      verifyCustomization.attr('maxlength', response)
      if (verifyCustomization.val().length < response) {
        jQuery('.customization-error').text('Please enter minimum character to proceed.').removeClass('hide').addClass('open') 
        jQuery('.Cart__Checkout').attr('disabled', 'disabled')
        jQuery('#Customization' + selectedVariantId).addClass('required')
        status = false
      }
    }
  }

  if (status && jQuery('#name-count').length) {
    $(".name_dropdown").each(function () {
      if (jQuery(this).val().length === 0) {
        jQuery('.namecount-error').text('Please enter a name to proceed to cart.').removeClass('hide').addClass('open')
        jQuery('#name-count').addClass('required') 
        nameRequired = true
        status = false;
      }
    });
    if (!nameRequired) {
      jQuery('.namecount-error').text('').removeClass('open').addClass('hide') 
      jQuery('#name-count').removeClass('required') 
      status = true;
    }
  }

  /* Add On Flyout Functionality- Selected Products Validation */
  if(selectedProductsData && selectedProductsData.length){
    selectedProductsData.forEach(function(product) {
      var dropdownContainer = document.getElementById("insert-dropdown-" + product.pId);
      if (dropdownContainer) {
        var selectElements = dropdownContainer.getElementsByTagName("select");
        var selectedValues = {};
        for (var i = 0; i < selectElements.length; i++) {
          var selectElement = selectElements[i];
          var selectedValue = selectElement.options[selectElement.selectedIndex].value;
          var selectName = selectElement.name;
          selectedValues[selectName] = selectedValue;
          
          if (selectElement.id === `option1-select-${product.pId}` && !selectedValue) {   /* Checking Option-1 Value */
            var validationElement = dropdownContainer.querySelector(`#validation-option1-${product.pId}`);
            selectElement.classList.add('required'); 
            validationElement.style.display = 'block';
            jQuery('.Cart__Checkout').attr('disabled', 'disabled');
            status = false;
          } else if (selectElement.id === `option1-select-${product.pId}` && selectedValue) {
            var validationElement = dropdownContainer.querySelector(`#validation-option1-${product.pId}`);
            selectElement.classList.add('required'); 
            validationElement.style.display = 'none';
            jQuery('.Cart__Checkout').removeAttr('disabled');
            status
          }
          if (selectElement.id === `option2-select-${product.pId}` && !selectedValue) {   /* Checking Option-2 Value */
            var validationElement = dropdownContainer.querySelector(`#validation-option2-${product.pId}`);
            selectElement.classList.add('required');
            validationElement.style.display = 'block';
            jQuery('.Cart__Checkout').attr('disabled', 'disabled');
            status = false;
          } else if (selectElement.id === `option2-select-${product.pId}` && selectedValue) {
            var validationElement = dropdownContainer.querySelector(`#validation-option2-${product.pId}`);
            selectElement.classList.remove('required');
            validationElement.style.display = 'none';
          }
          if (selectElement.id === `option3-select-${product.pId}` && !selectedValue) {   /* Checking Option-3 Value */
            var validationElement = dropdownContainer.querySelector(`#validation-option3-${product.pId}`);
            selectElement.classList.add('required');
            validationElement.style.display = 'block';
            jQuery('.Cart__Checkout').attr('disabled', 'disabled');
            status = false;
          } else if (selectElement.id === `option3-select-${product.pId}` && selectedValue) {
            var validationElement = dropdownContainer.querySelector(`#validation-option3-${product.pId}`);
            selectElement.classList.remove('required');
            validationElement.style.display = 'none';
          }
          if (selectElement.id === `option4-select-${product.pId}` && !selectedValue) {   /* Checking Option-4 Value */
            var validationElement = dropdownContainer.querySelector(`#validation-option4-${product.pId}`);
            selectElement.classList.add('required');
            validationElement.style.display = 'block';
            jQuery('.Cart__Checkout').attr('disabled', 'disabled');
            status = false;
          } else if (selectElement.id === `option4-select-${product.pId}` && selectedValue) {
            var validationElement = dropdownContainer.querySelector(`#validation-option4-${product.pId}`);
            selectElement.classList.remove('required');
            validationElement.style.display = 'none';
          }
        }
      }
    });
  }

  /* Gift Wrap Product: Name and Email validation */
  var emailValidation = true;
  var giftCardCheckBox = $('#gift-card-send-checkbox');
  if (giftCardCheckBox && giftCardCheckBox.length && giftCardCheckBox.is(":checked")) {
    const nameInput = document.getElementById('gift-card-recipient-name');
    const emailInput = document.getElementById('gift-card-recipient-email');
    const nameError = document.getElementById('gift-card-name-error');
    const emailError = document.getElementById('gift-card-email-error');
    
    // Gift Wrap Product: Validate Name
    if (nameInput.value.trim().length < 2) {
      nameError.style.display = 'block';
      status = false;
    } else {
      nameError.style.display = 'none';
      status = true;
    }
    // Gift Wrap Product: Validating Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailInput.value)) {
      emailError.style.display = 'block';
      status = false;
      emailValidation = false;
    } else {
      emailError.style.display = 'none';
      status = true;
      emailValidation = true;
    }    
  }

  if (status && status == true && !jQuery(".ProductForm__AddToCart").hasClass('weddingDatepopupbox')) {
    if(isCheckoutNowButtonPressed === false) jQuery(".ProductForm__AddToCart span:first").html('Adding...');
    disableAddToCartButton();
    /* Disabling Add on Flyout Dropdowns */
    $('.remove-product').removeClass('hide');
    $('.remove-product-disabled').addClass('hide');
    $('.handle-disabled-dropdown').prop('disabled',true)
  }

  requiredElem = $(addToCartForm).find("*[data-required='true']");
  if (requiredElem && requiredElem.length > 0) {
    var allRequiredFieldsArray = []
    var allRequiredFieldsArraySelect = []
    for (var i = 0; i < requiredElem.length; i++) {
      var requiredFieldValue = jQuery(requiredElem[i]).val().trim()
      var parentId = jQuery(requiredElem[i]).parent().attr('id')
      var customBox = parentId && parentId.toString().indexOf('btn-popover-') !== -1 ? true : false
      if (requiredFieldValue === '' && customBox) {
        validateElem.push(jQuery(requiredElem[i]).parent()[0])
        jQuery(requiredElem[i]).val('')
        allRequiredFieldsArray.push('nocustomstone')
      } else if (requiredFieldValue !== '' && customBox) {
        noneValidateElem.push(jQuery(requiredElem[i]).parent()[0])
      } else if (requiredFieldValue === '' && !customBox) {
        validateElem.push(requiredElem[i])
        jQuery(requiredElem[i]).val('')
        allRequiredFieldsArray.push('nocustomstone')
      } else if (requiredFieldValue !== '' && !customBox) {
        noneValidateElem.push(requiredElem[i])
      }
    }

    var requiredEleVal = jQuery(validateElem).val()
    var requiredEleVals = jQuery(noneValidateElem).val()
    if (noneValidateElem.length) {
      jQuery(noneValidateElem).removeClass("required")
    }
    if (allRequiredFieldsArray.indexOf("nocustomstone") !== -1) {
      jQuery(validateElem).addClass("required")
      cb(false)
    } else {
      if ((!requiredEleVal && validateElem.length) || !emailValidation) {
        jQuery(validateElem).addClass("required")
        cb(false)
      } else {
        jQuery(validateElem).removeClass("required")
        cb(true)
      }
    }
  } else {
    cb(true)
  }
}

function showNotifyMeMessage(data) {
  var productTags = currentProductJson ? currentProductJson.tags.join(",") : []
  if (data.inventory_management && data.inventory_policy === 'deny' && data.availableToSell <= 0
    && !data.isVariantLeadMessage && productTags.indexOf("dont-show-in-stock-popup") === -1) {
    jQuery("#notifyWhenInStockPopup").find(".js-productId").val(data.product_id)
    jQuery("#notifyWhenInStockPopup").find(".js-variant").val(data.id)
    jQuery("#notifyWhenInStockPopup").show()
    jQuery(".mejuri-card").hide()
    $('.customStockLevelMessage').addClass('hide');
    $('.stock-status--wrapper')[0]?.style.setProperty('margin-top', '0px', 'important');
  } else {
    jQuery("#notifyWhenInStockPopup").find(".js-productId").val("")
    jQuery("#notifyWhenInStockPopup").find(".js-variant").val("")
    jQuery("#notifyWhenInStockPopup").hide()
    jQuery(".ProductForm__AddToCart").show()
    jQuery(".mejuri-card").show()
    $('.customStockLevelMessage').removeClass('hide');
    $('.stock-status--wrapper')[0]?.style.setProperty('margin-top', '20px', 'important');
  }
}

function saveUserInNotifyApi() {
  try {
    var productId = jQuery("#notifyWhenInStockPopup").find(".js-productId").val()
    var variantId = jQuery("#notifyWhenInStockPopup").find(".js-variant").val()
    var email = jQuery("#notifyWhenInStockPopup").find(".js-email").val()
    if (productId && variantId && email) {
      $.ajax({
        url: `${portalApiUrl}/notify`,
        type: "POST",
        data: {
          productId,
          variantId,
          email
        },
        success: function (response) {
          jQuery("#notifyWhenInStockPopup").find(".apiResponseMessage").html(`<p>Thank you! We’ll let you know when this product has been restocked.</p>`)
          $("#notifyWhenInStockPopup").find("button").text("YOU’RE ON THE LIST")
          // Reloading the page after 10 seconds
          setTimeout(function () {
            window.location.reload()
          }, 10000)
        },
        error: function (error) {
          jQuery("#notifyWhenInStockPopup").find(".apiResponseMessage").html('<p class="Form__Alert Alert Alert--error">Some Error occured</p>')
        }
      });
    }
    return false
  } catch (error) {
    console.log('An error occurred:', error);
  }
}

/*** Fetch pear stone dropdown variants Array function ***/
var hidePearStoneTags = []
var pearstoneOptions = [];
function pearstoneDropdownArray() {
  var pearStoneHandle = `pear-stone-selection`;
  var cloudPearStone = currentProductJson ? currentProductJson.tags.filter(s => s.includes('cloud-pear-stone')) : [];
  if (cloudPearStone.length) pearStoneHandle = `toi-et-moi-cloud-pear-stone`;

  getProductByHandle(pearStoneHandle)
    .then(function (pearstonedropdownGhostProduct) {
      var tags = pearstonedropdownGhostProduct.product.tags.split(",");
      var hideStone = tags
        .map(tag => tag.trim())
        .filter(tag => tag.startsWith("Hide: "))
        .map(tag => tag.replace("Hide: ", ""));
      hidePearStoneTags = hideStone;
      var optionsArr = []
      for (var i = 0; i < pearstonedropdownGhostProduct.product.variants.length; i++) {
        var filteredNames = $(pearstonedropdownGhostProduct.product.images).filter(function (idx) {
          return pearstonedropdownGhostProduct.product.images[idx].id === pearstonedropdownGhostProduct.product.variants[i].image_id
        });
        $(filteredNames).each(function () {
          pearstonedropdownGhostProduct.product.variants[i].imageUrl = this.src;
        })
      }
      return pearstonedropdownGhostProduct.product.variants;
    }).then(function (options) {
      pearstoneOptions = options
      return pearstoneOptions
    })
}

/*** Fetch pear stone dropdown variants Array function ***/
var hideEmeraldStoneTags = []
var emeraldstoneOptions = [];
function emeraldstoneDropdownArray() {
  var emeraldStoneHandle = `emerald-stone-selection`;
  var cloudPEmeraldStone = currentProductJson ? currentProductJson.tags.filter(s => s.includes('cloud-emerald-stone')) : [];
  if (cloudPEmeraldStone.length) emeraldStoneHandle = `toi-et-moi-cloud-emerald-stone`;

  getProductByHandle(emeraldStoneHandle)
    .then(function (emeraldstonedropdownGhostProduct) {
      var tags = emeraldstonedropdownGhostProduct.product.tags.split(",");
      var hideStone = tags
        .map(tag => tag.trim())
        .filter(tag => tag.startsWith("Hide: "))
        .map(tag => tag.replace("Hide: ", ""));
      hideEmeraldStoneTags = hideStone;
      var optionsArr = []
      for (var i = 0; i < emeraldstonedropdownGhostProduct.product.variants.length; i++) {
        var filteredNames = $(emeraldstonedropdownGhostProduct.product.images).filter(function (idx) {
          return emeraldstonedropdownGhostProduct.product.images[idx].id === emeraldstonedropdownGhostProduct.product.variants[i].image_id
        });
        $(filteredNames).each(function () {
          emeraldstonedropdownGhostProduct.product.variants[i].imageUrl = this.src;
        })
      }
      return emeraldstonedropdownGhostProduct.product.variants;
    }).then(function (options) {
      emeraldstoneOptions = options
      return emeraldstoneOptions
    })
}

/*** Zodiac product variants ***/
var zodiacOptions = [];
function zodiacDropdownArray() {
  zodiacOptions = [
    { "variant_name": "Aquarius" },
    { "variant_name": "Pisces" },
    { "variant_name": "Aries" },
    { "variant_name": "Taurus" },
    { "variant_name": "Gemini" },
    { "variant_name": "Cancer" },
    { "variant_name": "Leo" },
    { "variant_name": "Virgo" },
    { "variant_name": "Libra" },
    { "variant_name": "Scorpio" },
    { "variant_name": "Sagittarius" },
    { "variant_name": "Capricorn" }
  ];
  return zodiacOptions;
}

/*** Custom Size Product variants ***/
var customSizeOptions = [];
var customSizeOptionsURL = false;
var showDefaultSelection = false;
var bespokeDefaultSelection = false;
function customSizeDropdownArray() {
  var customSizeDropDownEarrings = currentProductJson ? currentProductJson.tags.filter(s => s.includes('show-size-dropdown-earrings')) : [];
  var customDiamondCoverage = currentProductJson ? currentProductJson.tags.filter(s => s.includes('show-diamond-coverage-dropdown')) : [];
  var customSizeBespokeFlashProducts = currentProductJson ? currentProductJson.tags.filter(s => s.includes('show-bespoke-flash-product')) : [];
  if (customSizeDropDownEarrings && customSizeDropDownEarrings.length){
    customSizeOptionsURL = true;
    showDefaultSelection = true;
    customSizeOptions = [
      { "variant_name": "Mini (look of 0.75cttw studs)","variant_url": "javascript:void(0)" },
      { "variant_name": "S (look of 1cttw studs)", "variant_url": "/products/round-illusion-diamond-studs?variant=39755301060696" },
      { "variant_name": "M (look of 1.5cttw studs)", "variant_url": "/products/round-illusion-diamond-studs?variant=39755301060696" },
      { "variant_name": "L (look of 2cttw studs)", "variant_url": "/products/round-illusion-diamond-studs?variant=39755301060696" },
      { "variant_name": "XL (look of 3cttw studs)", "variant_url": "/products/round-illusion-diamond-studs?variant=39755301060696" },
      { "variant_name": "2X (look of 4cttw studs)", "variant_url": "/products/round-illusion-diamond-studs?variant=39755301060696" },
      { "variant_name": "3X (look of 5cttw studs)", "variant_url": "/products/round-illusion-diamond-studs?variant=39755301060696" },
      { "variant_name": "4X (look of 6cttw studs)", "variant_url": "/products/round-illusion-diamond-studs?variant=39755301060696" }
    ];
  } else if(customSizeBespokeFlashProducts && customSizeBespokeFlashProducts.length){
    bespokeDefaultSelection = true;
    customSizeOptions = [
      { "variant_name": "3" },
      { "variant_name": "3.25" },
      { "variant_name": "3.5" },
      { "variant_name": "3.75" },
      { "variant_name": "4" },
      { "variant_name": "4.25" },
      { "variant_name": "4.5" },
      { "variant_name": "4.75" },
      { "variant_name": "5" },
      { "variant_name": "5.25" },
      { "variant_name": "5.5" },
      { "variant_name": "5.75" },
      { "variant_name": "6" },
      { "variant_name": "6.25" },
      { "variant_name": "6.5" },
      { "variant_name": "6.75" },
      { "variant_name": "7" },
      { "variant_name": "7.25" },
      { "variant_name": "7.5" },
      { "variant_name": "7.75" },
      { "variant_name": "8" },
      { "variant_name": "8.25" },
      { "variant_name": "8.5" },
      { "variant_name": "8.75" },
      { "variant_name": "9" }
    ]
  } else {
    customSizeOptions = [
      { "variant_name": "2" },
      { "variant_name": "2.5" },
      { "variant_name": "3" },
      { "variant_name": "3.5" },
      { "variant_name": "4" },
      { "variant_name": "4.5" },
      { "variant_name": "5" },
      { "variant_name": "5.5" },
      { "variant_name": "6" },
      { "variant_name": "6.5" },
      { "variant_name": "7" },
      { "variant_name": "7.5" },
      { "variant_name": "8" },
      { "variant_name": "8.5" },
      { "variant_name": "9" },
      { "variant_name": "I don't know my size; send me a Ring Sizing Gauge!" }
    ];
  }
  return customSizeOptions;
}

/*** Fetch mens size dropdown variants Array function ***/
var mensSizeOptions = [];
function mensSizeDropdownArray() {
  getProductByHandle(`mens-size`)
    .then(function (mensSizedropdownGhostProduct) {
      var optionsArr = []
      for (var i = 0; i < mensSizedropdownGhostProduct.product.variants.length; i++) {
        var filteredNames = $(mensSizedropdownGhostProduct.product.images).filter(function (idx) {
          return mensSizedropdownGhostProduct.product.images[idx].id === mensSizedropdownGhostProduct.product.variants[i].image_id
        });
        $(filteredNames).each(function () {
          mensSizedropdownGhostProduct.product.variants[i].imageUrl = this.src;
        })
      }
      return mensSizedropdownGhostProduct.product.variants;
    }).then(function (options) {
      mensSizeOptions = options
      return mensSizeOptions
    })
}

/*** Fetch womens size dropdown variants Array function ***/
var womensSizeOptions = [];
function womensSizeDropdownArray() {
  getProductByHandle(`womens-size`)
    .then(function (womensSizedropdownGhostProduct) {
      var optionsArr = []
      for (var i = 0; i < womensSizedropdownGhostProduct.product.variants.length; i++) {
        var filteredNames = $(womensSizedropdownGhostProduct.product.images).filter(function (idx) {
          return womensSizedropdownGhostProduct.product.images[idx].id === womensSizedropdownGhostProduct.product.variants[i].image_id
        });
        $(filteredNames).each(function () {
          womensSizedropdownGhostProduct.product.variants[i].imageUrl = this.src;
        })
      }
      return womensSizedropdownGhostProduct.product.variants;
    }).then(function (options) {
      womensSizeOptions = options
      return womensSizeOptions
    })
}

/*** Fetch name count product options ***/
function namecount(v) {
  jQuery('#name-count').html("")
  var vals = getOptionsVals(v, 'Name Count')
  var matches = currentProductJson.tags.filter(s => s.includes('name-count'));
  var htmlDiv = ''
  if (vals && vals !== 0 && vals !== '0') {
    for (var i = 1; i <= vals; i++) {
      htmlDiv += `<div class="ProductForm__Option">`;
      htmlDiv += `<input type="text" name="properties[Name_` + i + `]" id="personalized_name_` + i + `" class="name_dropdown custom_stone_variant_option vow-form-control vow-form-control-light" placeholder="Name ` + i + `"  data-required="true" value="` + names[i - 1] + `">`;
      htmlDiv += `<span id="preview_text_` + i + `" class="preview-text" style="letter-spacing: -4px; text-transform: uppercase; font-family:` + fontFamily[i - 1] + `;">` + names[i - 1] + `</span>`
      htmlDiv += `<div class="errormsg hide namecount-error"></div>`
      htmlDiv += `</div>`;
    }
    jQuery('#name-count').append(htmlDiv)
  } else {
    console.log("option2 is not a number")
  }
  var grabFontFamily = $('#grab_name_count').val();
  if (grabFontFamily == 'AVERY' || grabFontFamily == 'Arial-Black' || grabFontFamily == 'Seagramftb') {
    $('.preview-text').css('letter-spacing', '-4px')
  }
  if (grabFontFamily == 'Achilles' || grabFontFamily == 'Arial-Black' || grabFontFamily == 'DTestFont' || grabFontFamily == 'Noto Sans JP') {
    $('.preview-text').css("text-transform", "uppercase");
  }
  if (grabFontFamily == 'Bernhard Tango') {
    grabFontFamily = 'BernhardTangoBT';
  }
  $('#personalized_name_1').on('keyup', function () {
    var getValue = $('#personalized_name_1').val();
    names[0] = $('#personalized_name_1').val();
    if (grabFontFamily) {
      $('#preview_text_1').text(getValue);
      $('#preview_text_1').css('font-family', grabFontFamily.replaceAll(/\s/g, ''))
      fontFamily[0] = grabFontFamily.replaceAll(/\s/g, '')
    }
  });
  $('#personalized_name_2').on('keyup', function () {
    var getValue = $('#personalized_name_2').val();
    names[1] = $('#personalized_name_2').val();
    if (grabFontFamily) {
      $('#preview_text_2').text(getValue);
      $('#preview_text_2').css('font-family', grabFontFamily.replaceAll(/\s/g, ''))
      fontFamily[1] = grabFontFamily.replaceAll(/\s/g, '')
    }
  });
  $('#personalized_name_3').on('keyup', function () {
    var getValue = $('#personalized_name_3').val();
    names[2] = $('#personalized_name_3').val();
    if (grabFontFamily) {
      $('#preview_text_3').text(getValue);
      $('#preview_text_3').css('font-family', grabFontFamily.replaceAll(/\s/g, ''))
      fontFamily[2] = grabFontFamily.replaceAll(/\s/g, '')
    }
  });
  $('#personalized_name_4').on('keyup', function () {
    var getValue = $('#personalized_name_4').val();
    names[3] = $('#personalized_name_4').val();
    if (grabFontFamily) {
      $('#preview_text_4').text(getValue);
      $('#preview_text_4').css('font-family', grabFontFamily.replaceAll(/\s/g, ''))
      fontFamily[3] = grabFontFamily.replaceAll(/\s/g, '')
    }
  });
  $('#personalized_name_5').on('keyup', function () {
    var getValue = $('#personalized_name_5').val();
    names[4] = $('#personalized_name_5').val();
    if (grabFontFamily) {
      $('#preview_text_5').text(getValue);
      $('#preview_text_5').css('font-family', grabFontFamily.replaceAll(/\s/g, ''))
      fontFamily[4] = grabFontFamily.replaceAll(/\s/g, '')
    }
  });
  enableAddToCartButton()
  stopScreenFreeze()
}

function getImageURLByTitle(title) {
  var baseURL = "https://ringconcierge.com/cdn/shop/files/14k-";
  var colorURL = "https://cdn.shopify.com/s/files/1/1359/2701/files/";
  if (title.toLowerCase().includes("yellow")) {
    return baseURL + "yellow-gold_64x64.png?v=1695022370";
  } else if (title.toLowerCase().includes("white")) {
    return baseURL + "white-gold_64x64.png?v=1720481857";
  } else if (title.toLowerCase().includes("rose")) {
    return baseURL + "rose-gold_64x64.png?v=1720481873";
 } else if (title.toLowerCase().includes("cream")) {
    return colorURL + "ic-cream-color.png?v=1731418611";
 } else if (title.toLowerCase().includes("black")) {
    return colorURL + "ic-black-color.png?v=1731418627";
 } else if (title.toLowerCase().includes("gold vermeil")) {
    return colorURL + "VERMEIL-01.svg?v=1752646294";
 } else {
    return null; // or return a default URL if needed
  }
}

function changeMetalColor(e){
  var title = $(e).attr("data-title");
  var varId = $(e).attr("data-value");
  $("#color-dropdown").find("span.ProductForm__SelectedValue").text(title)
  $(".Color-circle").removeClass("is-active");
  $(e).find("label.Color-circle").addClass("is-active");
  $('input[name="properties[Color]"]').val(title);
  $('input[name="properties[Color_Dropdown]"]').val(varId);
}

/* Color dropdown */
var defaultMetalName = '14k Yellow Gold';
var defaultMetalVarId = '39513020694616';
function colorDropDown(v) {
  jQuery('#color-dropdown').html("")
  var htmlDiv = ''
  var appendArray = []
  if (v) {
    htmlDiv += `<span class="Product-Form__Label">Metal: <span class="ProductForm__SelectedValue">14k Yellow Gold</span></span>`;
    htmlDiv += `<ul class="color-dropdown-list">`
    for (var k = 0; k < colordropOptions.length; k++) {
      var variant = colordropOptions[k];
      var imageURL = getImageURLByTitle(variant.title);
      htmlDiv += `<li class="HorizontalList__Item" oldId="` + v.id + `" image-url="` + imageURL + `" index="` + k + `" data-price="` + variant.price + `" data-title="` + variant.title + `" data-value="` + variant.id + `" onclick="changeMetalColor(this)">`;
      htmlDiv += `<input id="option-product-template-0-` + k + `" class="ColorCircle__Radio" type="radio" name="option-0" value="${variant.title}" checked="checked" data-option-position="1" autofilled="">`;
      htmlDiv += `<label for="option-product-template-0-` + k + `" class="Color-circle ` + (k === 0 ? 'is-active' : '') + `" data-tooltip="${variant.title}" style="background-color: silver; background-image: url(${imageURL})"><span class="u-visually-hidden">${variant.title}</span></label>`;
      htmlDiv += `</li>`;
    }
    htmlDiv += `<input type="hidden" name="properties[Color]" class="color_dropdown_title` + v.id + `_selectedvalue" value='` + defaultMetalName + `'>`;
    htmlDiv += `<input type="hidden" name="properties[Color_Dropdown]" class="color_dropdown_` + v.id + `_selectedvalue" value='` + defaultMetalVarId + `' data-required='true'>`;
    htmlDiv += `</ul>`
    
    jQuery('#color-dropdown').append(htmlDiv)
    enableAddToCartButton()
    stopScreenFreeze()
  } else {
    console.log("option2 is not a number")
  }
}
   
/* Pear stone dropdown */
var pearStoneImg = "https://cdn.shopify.com/s/files/1/1359/2701/products/ring-concierge-white-topaz-pear-stone-selection-29376064520280.jpg?v=1680050460";
var pearStoneValue = "39871074664536";
var pearStoneTitle = " White Topaz";

var cloudPearStone = currentProductJson ? currentProductJson.tags.filter(s => s.includes('cloud-pear-stone')) : [];
if (cloudPearStone.length){
  pearStoneImg = "https://cdn.shopify.com/s/files/1/1359/2701/products/ring-concierge-pear-stone-selection-29376065503320_430x.jpg?v=1680050460#";
  pearStoneValue = "43694256390232";
  pearStoneTitle = " Red Garnet";
}

function pearstoneDropDown(v) {
  // Guard: if options not loaded yet, retry after 300ms
  if (pearstoneOptions.length === 0) {
    setTimeout(function () {
      pearstoneDropDown(v);
    }, 300);
    return;
  }
  jQuery('#pearstoneWrapper').html("")
  var htmlDiv = ''
  var appendArray = []
  if (v) {
    htmlDiv += `<div class="ProductForm__Option pearstone-dropdown">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-pearstone-dropdown-options" type="button" class="ProductForm__Item pearstone_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-pesrstone-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">Pear Stone </span><span class="ProductForm__SelectedValuePearstone` + v.id + ` dropdown-selected-value"><img src=` + pearStoneImg + ` alt="` + pearStoneTitle + `" class="stone-thumb-selected"><span class="stone-title"> ` + pearStoneTitle + `</span></span></span>` /* RC-31 removed ":" from label*/
    htmlDiv += `<input type="hidden" name="properties[Pear-Stone]" class="pearstone_dropdown_title` + v.id + `_selectedvalue" value="` + pearStoneTitle + `">`;
    htmlDiv += `<input type="hidden" name="properties[_Pearstone_v_id]" class="pearstone_dropdown_` + v.id + `_selectedvalue" value=` + pearStoneValue + ` data-required='true'>`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-pearstone-dropdown-options" class="OptionSelector pearstone_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">Pear Stone</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList pearstone-dropdown" data-scrollable="">`;
    for (var j = 0; j < pearstoneOptions.length; j++) {
      var variant = pearstoneOptions[j];
      if (hidePearStoneTags.includes(variant.title)) {
        continue;
      }
      htmlDiv += `<button type="button" class="pearstone_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" image-url="` + variant.imageUrl + `" index="` + j + `" data-price="` + variant.price + `" data-title="` + variant.title + `" data-value="` + variant.id + `">`;
      htmlDiv += `<img src="` + variant.imageUrl + `" alt="` + variant.title + `" class="stone-thumb"/>`;
      htmlDiv += `<span class="dropdown-title">` + variant.title + `</span>`;
      htmlDiv += `</button>`;
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;

    $('#pearstoneWrapper').append(htmlDiv)
    $('body').css("overflow", "visible");
    enableAddToCartButton()
    setClickActionPearstone()
    stopScreenFreeze()
  } else {
    $(".ProductForm__AddToCart").removeClass("BlackWhiteCustomizer");
    $(".stock-level-message").html("");
    $(".custom-stock-level-message").removeClass("clock-enabled");
    console.log("option2 is not a number");
  }
}

/* Emerald stone dropdown */
var emeraldStoneImg = "https://cdn.shopify.com/s/files/1/1359/2701/products/ring-concierge-emerald-stone-selection-29376087752792.jpg?v=1680063076";
var emeraldStoneValue = "39871077384280";
var emeraldStoneTitle = "London Blue Topaz";
var defaultImage = "https://ringc-variant.s3.us-east-2.amazonaws.com/colors/y/y-london-blue-topaz-white-topaz.jpg";

var cloudEmeraldStone = currentProductJson ? currentProductJson.tags.filter(s => s.includes('cloud-emerald-stone')) : [];
if (cloudEmeraldStone.length){
  emeraldStoneValue = "43694300561496";
  emeraldStoneTitle = "White Moonstone";
  emeraldStoneImg = "https://cdn.shopify.com/s/files/1/1359/2701/products/ring-concierge-white-topaz-pear-stone-selection-29376064520280_430x.jpg?v=1680050460#";
}

function emeraldstoneDropDown(v) {
  // Guard: if options not loaded yet, retry after 300ms
  if (emeraldstoneOptions.length === 0) {
    setTimeout(function () {
      emeraldstoneDropDown(v);
    }, 300);
    return;
  }
  jQuery('#emeraldstoneWrapper').html("")
  var htmlDiv = ''
  var appendArray = []
  if (v) {
    htmlDiv += `<div class="ProductForm__Option emeraldstone-dropdown">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-emeraldstone-dropdown-options" type="button" class="ProductForm__Item emeraldstone_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-emeraldstone-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">Emerald Stone </span><span class="ProductForm__SelectedValueEmeraldstone` + v.id + ` dropdown-selected-value"><img src=` + emeraldStoneImg + ` alt="` + emeraldStoneTitle + `" class="stone-thumb-selected"><span class="stone-title"> ` + emeraldStoneTitle + `</span></span></span>` /* RC-31 removed ":" from label*/
    htmlDiv += `<input type="hidden" name="properties[Emerald-Stone]" class="emeraldstone_dropdown_title` + v.id + `_selectedvalue" value="` + emeraldStoneTitle + `">`;
    htmlDiv += `<input type="hidden" name="properties[_Emerlad_stone_v_id]" class="emeraldstone_dropdown_` + v.id + `_selectedvalue" value=` + emeraldStoneValue + ` data-required='true'>`;
    if (!cloudEmeraldStone.length) htmlDiv += `<input type="hidden" name="properties[_toi_moi_image]" value="${defaultImage}">`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-emeraldstone-dropdown-options" class="OptionSelector emeraldstone_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">Emerald Stone</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList emeraldstone-dropdown" data-scrollable="">`;
    for (var j = 0; j < emeraldstoneOptions.length; j++) {
      var variant = emeraldstoneOptions[j];
      if (hideEmeraldStoneTags.includes(variant.title)) {
        continue;
      }
      htmlDiv += `<button type="button" class="emeraldstone_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" image-url="` + variant.imageUrl + `" index="` + j + `" data-price="` + variant.price + `" data-title="` + variant.title + `" data-value="` + variant.id + `">`;
      htmlDiv += `<img src="` + variant.imageUrl + `" alt="` + variant.title + `" class="stone-thumb"/>`;
      htmlDiv += `<span class="dropdown-title">` + variant.title + `</span>`;
      htmlDiv += `</button>`;
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    
    jQuery('#emeraldstoneWrapper').append(htmlDiv)
    $('body').css("overflow", "visible");
    enableAddToCartButton()
    setClickActionEmeraldstone()
    stopScreenFreeze()
    if (!cloudEmeraldStone.length)
    previewColorCombinationButton("_toi_moi_image");
  } else {
    console.log("option2 is not a number")
  }
}

/* ==== Custom Charm Count Dropdown ==== */
function charmCountDropDown(v) {
  var charmCountOptions = [
    { id: "a8f3k2d1", title: 1 },
    { id: "x9p2lm4q", title: 2 },
    { id: "k3j8s1z0", title: 3 },
    { id: "p0q9w8e7", title: 4 },
    { id: "m4n2b7v6", title: 5 }
  ]
  jQuery('#charmCountWrapper').html("")
  var htmlDiv = ''
  var appendArray = []
  if (v) {
    htmlDiv += `<div class="ProductForm__Option charmcount-dropdown">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-charmcount-dropdown-options" type="button" class="ProductForm__Item charmcount_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-charmcount-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName "><span class="dropdown-lable">Charm Count: </span><span class="ProductForm__SelectedValueCharmCount` + v.id + ` dropdown-selected-value">1</span></span>` 
    htmlDiv += `<input type="hidden" name="properties[Charm_Count]" class="charmcount_dropdown_title` + v.id + `_selectedvalue" value='1'>`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-charmcount-dropdown-options" class="OptionSelector charmcount_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList charmcount-dropdown" data-scrollable="">`;
    for (var j = 0; j < charmCountOptions.length; j++) {
      var variant = charmCountOptions[j];
      htmlDiv += `<button type="button" class="charmcount_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-price="0" data-title="` + variant.title + `" data-value="` + variant.id + `">`;
      htmlDiv += `<span class="dropdown-title">` + variant.title + `</span>`;
      htmlDiv += `<div class="popover-value-stock">
                    <span class="variant-lead-time">
                      <span class="dropdown-lead-time" data-custom-lead-time="" data-lt-var-custom-lead-time="" data-lt-var-selling-policy="` + v.inventory_policy + `" data-lt-var-id="`+ v.id +`"></span>
                    </span> 
                  </div>`;
      htmlDiv += `</button>`;
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;
    jQuery('#charmCountWrapper').append(htmlDiv)
    setClickActionCharmCount()
  } else {
    console.log("option2 is not a number")
  }
}

/* Zodiac One Product Dropdown */
var zodiacOneTitle = "Aries";
function zodiacOneProductDropDown(v) {
  jQuery('#zodiacOneWrapper').html("")
  var htmlDiv = ''
  if (v) {
    htmlDiv += `<div class="ProductForm__Option zodiac-one-dropdown">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-zodiac-one-dropdown-options" type="button" class="ProductForm__Item zodiac_one_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-zodiac-one-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">Zodiac 1 </span><span class="ProductForm__SelectedValueZodiacOne` + v.id + ` dropdown-selected-value">` + zodiacOneTitle + `</span></span>`
    htmlDiv += `<input type="hidden" name="properties[zodiac_one]" class="zodiac_one_dropdown_title` + v.id + `_selectedvalue" value='` + zodiacOneTitle + `' data-required="true">`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button></div>`;
    var htmlDivPop = '';
    htmlDivPop += `<div id="popover-` + v.id + `-product-template-zodiac-one-dropdown-options" class="OptionSelector zodiac_one_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDivPop += `<header class="Popover__Header">`;
    htmlDivPop += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDivPop += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDivPop += `</svg></button>`;
    htmlDivPop += `<span class="Popover__Title Heading u-h4">Zodiac 1</span>`;
    htmlDivPop += `</header>`
    htmlDivPop += `<div class="Popover__Content">`;
    htmlDivPop += `<div class="Popover__ValueList zodiac-one-dropdown" data-scrollable="">`;
    for (var j = 0; j < zodiacOptions.length; j++) {
      var variant = zodiacOptions[j];
      htmlDivPop += `<button type="button" class="zodiac_one_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-title="` + variant.variant_name + `" data-value="` + variant.variant_name + `">`;
      htmlDivPop += `<span class="dropdown-title">` + variant.variant_name + `</span>`;
      htmlDivPop += `</button>`;
    }
    htmlDivPop += `</div>`;
    htmlDivPop += `</div>`;
    htmlDivPop += `</div>`;

    $('.Product__Wrapper').after(htmlDivPop)
    $('#zodiacOneWrapper').append(htmlDiv)
    $('body').css("overflow", "visible");
    enableAddToCartButton()
    setClickActionZodiacOne()
    stopScreenFreeze()
  } else {
    console.log("option2 is not a number")
  }
}

/* Zodiac Two Product Dropdown */
var zodiacTwoTitle = "Aries";
function zodiacTwoProductDropDown(v) {
  jQuery('#zodiacTwoWrapper').html("")
  var htmlDiv = ''
  if (v) {
    htmlDiv += `<div class="ProductForm__Option zodiac-two-dropdown">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-zodiac-two-dropdown-options" type="button" class="ProductForm__Item zodiac_two_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-zodiac-two-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">Zodiac 2 </span><span class="ProductForm__SelectedValueZodiacTwo` + v.id + ` dropdown-selected-value">` + zodiacTwoTitle + `</span></span>`
    htmlDiv += `<input type="hidden" name="properties[zodiac_two]" class="zodiac_two_dropdown_title` + v.id + `_selectedvalue" value='` + zodiacTwoTitle + `' data-required="true">`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button></div>`;
    var htmlDivPop = '';
    htmlDivPop += `<div id="popover-` + v.id + `-product-template-zodiac-two-dropdown-options" class="OptionSelector zodiac_two_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDivPop += `<header class="Popover__Header">`;
    htmlDivPop += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDivPop += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDivPop += `</svg></button>`;
    htmlDivPop += `<span class="Popover__Title Heading u-h4">Zodiac 2</span>`;
    htmlDivPop += `</header>`
    htmlDivPop += `<div class="Popover__Content">`;
    htmlDivPop += `<div class="Popover__ValueList zodiac-two-dropdown" data-scrollable="">`;
    for (var j = 0; j < zodiacOptions.length; j++) {
      var variant = zodiacOptions[j];
      htmlDivPop += `<button type="button" class="zodiac_two_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-title="` + variant.variant_name + `" data-value="` + variant.variant_name + `">`;
      htmlDivPop += `<span class="dropdown-title">` + variant.variant_name + `</span>`;
      htmlDivPop += `</button>`;
    }
    htmlDivPop += `</div>`;
    htmlDivPop += `</div>`;
    htmlDivPop += `</div>`;

    jQuery('.Product__Wrapper').after(htmlDivPop)
    jQuery('#zodiacTwoWrapper').append(htmlDiv)
    $('body').css("overflow", "visible");
    enableAddToCartButton()
    setClickActionZodiacTwo()
    stopScreenFreeze()
    previewColorCombinationButton("_zodiac_image")
  } else {
    console.log("option2 is not a number")
  }
}

async function filterTagsContainingBespokeSize(tags) {
  var bespokeSizeTags = tags.filter(tag => tag.includes('bespoke-size-'));
  var bespokeSizes = bespokeSizeTags.map(tag => parseFloat(tag.replace('bespoke-size-', '')));
  return bespokeSizes;
}

/* Custom Size Product Dropdown */
async function customSizeDropDown(v) {
  jQuery('#customSizeWrapper').html("")
  var htmlDiv = ''
  var bespokeSizeTags = await filterTagsContainingBespokeSize(currentProductJson.tags);
  var grabDropDownName = currentProductJson.tags.filter(s => s.includes('show-bespoke-flash-product'));
  var isOMSLeadTimeMadeToOrder = currentProductJson ? currentProductJson.tags.filter(s => s.includes('fetch-oms-leadtime-made-to-order')) : [];
  var productProperty = "Select";
  if (grabDropDownName && grabDropDownName.length && bespokeSizeTags.length !== 0) productProperty = bespokeSizeTags[0];
  htmlDiv += `<span class="ProductForm__Label customflex">Size: <a href="javascript:void(0)" onclick="openSizeDrawer()" class="manage-custom-size custom-all-size-guide" tabindex="0">Size Guide</a></span>`;
  if (v && bespokeSizeTags.length !== 0) {
    htmlDiv += `<div class="ProductForm__Option custom-size-dropdown">`;
    htmlDiv += `<div class="size-picker"><button id="btn-popover-` + v.id + `-product-template-custom-size-dropdown-options" type="button" class="ProductForm__Item custom_size_drop_down option-new-style" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-custom-size-dropdown-options">`;
    if(showDefaultSelection && showDefaultSelection === true){
      htmlDiv += `<span class="ProductForm__OptionName"><span class="ProductForm__SelectedValueCustomSize` + v.id + ` dropdown-selected-value">` + customSizeOptions[0].variant_name + `</span></span>`
      htmlDiv += `<input type="hidden" name="properties[Size]" class="custom_size_dropdown_title` + v.id + `_selectedvalue" value='`+ customSizeOptions[0].variant_name +`' data-required="true">`;
    } else if(bespokeDefaultSelection && bespokeDefaultSelection === true){
      htmlDiv += `<span class="ProductForm__OptionName"><span class="ProductForm__SelectedValueCustomSize` + v.id + ` dropdown-selected-value">`+ productProperty +`</span></span>`
      htmlDiv += `<input type="hidden" name="properties[Size]" class="custom_size_dropdown_title` + v.id + `_selectedvalue" value='`+ productProperty +`' data-required="true">`;
    } else {
      htmlDiv += `<span class="ProductForm__OptionName"><span class="ProductForm__SelectedValueCustomSize` + v.id + ` dropdown-selected-value">Select</span></span>`
      htmlDiv += `<input type="hidden" name="properties[Size]" class="custom_size_dropdown_title` + v.id + `_selectedvalue" value='' data-required="true">`;
    }  
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button><div id="popover-` + v.id + `-product-template-custom-size-dropdown-options" class="OptionSelector custom_size_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    var htmlDivPop = '';
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">Size</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList custom-size-dropdown" data-scrollable="">`;
    for (var j = 0; j < customSizeOptions.length; j++) {
      var variant = customSizeOptions[j];
      if(customSizeOptionsURL && customSizeOptionsURL === true){
        htmlDiv += `<a href="`+ variant.variant_url +`" style="text-decoration:none"><button type="button" class="custom_size_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-title="` + variant.variant_name + `" data-value="` + variant.variant_name + `">`;
        htmlDiv += `<span class="dropdown-title">` + variant.variant_name + `</span>`;
        htmlDiv += `</button></a>`;
      } else {
        htmlDiv += `<button type="button" class="custom_size_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-title="` + variant.variant_name + `" data-value="` + variant.variant_name + `">`;
        htmlDiv += `<span class="dropdown-title">` + variant.variant_name + `</span>`;
        if (grabDropDownName && grabDropDownName.length) {
          if(parseFloat(bespokeSizeTags) === parseFloat(variant.variant_name) && isOMSLeadTimeMadeToOrder.length === 0){
            htmlDiv += `<span class="popover-value-stock"><span class="popover-value-stock-label">In Stock</span></span>`
          } else {
            htmlDiv += `<span class="popover-value-stock"><span class="popover-value-stock-label">Made to Order</span></span>`
          }
        }
        htmlDiv += `</button>`;
      }
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    if ($(".Metal.Color.ProductForm__Option").length !== 0) {
      $(".Metal.Color.ProductForm__Option").after(htmlDiv)
    } else {
      $('#customSizeWrapper').append(htmlDiv)
    }
 
    var bespokeSizeTags = await filterTagsContainingBespokeSize(currentProductJson.tags);

    if(bespokeDefaultSelection && bespokeDefaultSelection === true && isOMSLeadTimeMadeToOrder.length === 0){
      var customSizeBespokeFlashProductsSoldOut = currentProductJson ? currentProductJson.tags.filter(s => s.includes('is-bespoke-sold-out')) : [];
      var ifLeadTimeFieldIsPresent = jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).length
      if(customSizeBespokeFlashProductsSoldOut && customSizeBespokeFlashProductsSoldOut.length !== 0){
        $(".stock-level-message").html("Sold out");
        $(".popover-value-stock-label").html("Sold out");
      } else {
        var selectedValue = $('.ProductForm__SelectedValueCustomSize'+v.id).text();
        if(bespokeSizeTags.includes(parseFloat(selectedValue))){
          $(".stock-level-message").html("Only 1 left in stock!")
          $('.inv-label--in-stock').removeClass('hide')
          $('.inv-label--out-stock').addClass('hide')
          if (ifLeadTimeFieldIsPresent > 0) {
            jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", 'Only 1 left in stock!')
          } else {
            jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value="Only 1 left in stock!" />`)
          }
        } else {
          $(".stock-level-message").html("Estimated production time is 2 weeks.")
          $('.inv-label--out-stock').removeClass('hide')
          $('.inv-label--in-stock').addClass('hide')
          $('.stock-status--wrapper').addClass('add-spacing-lead-time')
          if (ifLeadTimeFieldIsPresent > 0) {
            jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", 'Estimated production time is 2 weeks.')
          } else {
            jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value="Estimated production time is 2 weeks." />`)
          }
        }
      }
    }
    
    $('body').css("overflow", "visible");
    /* Enabling Add to cart button */
    enableAddToCartButton()
    setClickActionCustomSize()
    stopScreenFreeze()
  } else {
    console.log("option2 is not a number")
  }
}

/* Custom Size Dropdown: Earrings */
function customSizeDropDownEarrings(v) {
  jQuery('#customSizeEarringsWrapper').html("")
  var htmlDiv = ''
  var grabCustomEarringSize = currentProductJson && currentProductJson.title.toLowerCase().indexOf('petite') !== -1 ? 'Petite' : 'Mini';

  if (v) {
    htmlDiv += `<div class="ProductForm__Option custom-size-dropdown">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-carat-weight-dropdown-options" type="button" class="ProductForm__Item carat_weight_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-carat-weight-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">Size</span><span class="ProductForm__SelectedValuCaratWeight` + v.id + ` dropdown-selected-value">`+ grabCustomEarringSize +`</span></span>`
    htmlDiv += `<input type="hidden" name="properties[Size]" class="carat_weight_dropdown_title` + v.id + `_selectedvalue" value="`+ grabCustomEarringSize +`">`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-carat-weight-dropdown-options" class="OptionSelector carat_weight_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">Size</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList custom-size-dropdown" data-scrollable="">`;
    /* Custom Size Earrings Popover */
    htmlDiv += `<a class="hide-underline" href="/products/mini-diamond-line-studs"><button type="button" class="carat_weight_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="1" data-title="Mini" data-value="Mini">`;
    htmlDiv += `<span class="dropdown-title">Mini</span>`;
    htmlDiv += `</button></a>`;
    htmlDiv += `<a class="hide-underline" href="/products/pave-diamond-line-studs"><button type="button" class="carat_weight_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="1" data-title="Petite" data-value="Petite>`;
    htmlDiv += `<span class="dropdown-title">Petite</span>`;
    htmlDiv += `</button></a>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    if ($(".Metal.ProductForm__Option").length !== 0) {
      $(".Metal.ProductForm__Option").after(htmlDiv)
    } else {
      $('#customSizeEarringsWrapper').append(htmlDiv)
    }
    $('body').css("overflow", "visible");
    enableAddToCartButton()
    setClickActionCaratWeight()
    stopScreenFreeze()
  } else {
    console.log("option2 is not a number")
  }
}

var dropdownValues = [
  "Half",
  "Eternity"
]
var dropdownJSON = {
  "Half": [
    "Petite (3.5 Carat)",
    "Classic (6 Carat)"
  ],
  "Eternity": [
    "Petite (2 Carat)",
    "Classic (3 Carat)"
  ]
};
function customSizeDropDownDiamondCoverage(v) {
  var prefix = "Diamond Coverage: "
  var filteredTags = currentProductJson.tags.filter(tag => tag.startsWith(prefix));
  var textAfterPrefix = filteredTags.map(tag => tag.slice(prefix.length));
  textAfterPrefix = textAfterPrefix[0];
  var productProperty = "Width";
  var grabDropDownName = "Diamond";
  if (textAfterPrefix && textAfterPrefix.length) {
    grabDropDownName = textAfterPrefix;
    productProperty = textAfterPrefix;
  }
  jQuery('#customDiamondCoverageWrapper').html("")
  var htmlDiv = ''
  var grabCustomDiamondSize = currentProductJson && currentProductJson.title.toLowerCase().indexOf('eternity') !== -1 ? 'Eternity' : 'Half';
  if (v) {
    htmlDiv += `<div class="ProductForm__Option ${grabDropDownName}">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-diamond-coverage-dropdown-options" type="button" class="ProductForm__Item diamond_coverage_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-diamond-coverage-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName ${grabDropDownName}"><span class="dropdown-lable">${grabDropDownName}: </span><span class="ProductForm__SelectedValue_Diamond_Coverage` + v.id + ` dropdown-selected-value">${dropdownValues[0]}</span></span>` 
    htmlDiv += `<input type="hidden" name="properties[${productProperty}]" class="diamond_coverage_dropdown_title` + v.id + `_selectedvalue" value=''>`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-diamond-coverage-dropdown-options" class="OptionSelector diamond_coverage_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">Diamond Coverage</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList diamond-coverage-dropdown" data-scrollable="">`;
    for(let i=0; i<dropdownValues.length; i++){
      htmlDiv += `<button type="button" class="diamond_coverage_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" onclick="handleDropdownValues('${dropdownValues[i]}')" oldId="` + v.id + `" index="${i}" data-value=${dropdownValues[i]} data-title=${dropdownValues[i]}>`;
      htmlDiv += `<span class="dropdown-title">${dropdownValues[i]}</span>`;
      htmlDiv += `</button>`;
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    if ($(".Metal.ProductForm__Option").length !== 0) {
      $(".Metal.ProductForm__Option").after(htmlDiv)
    } else {
      jQuery('#customDiamondCoverageWrapper').append(htmlDiv)
    }
    /* Enabling Add to cart button */
    enableAddToCartButton()
    setClickActionDiamondCoverage()
    stopScreenFreeze()
    handleDropdownValues(dropdownValues[0])
  } else {
    console.log("option2 is not a number")
  }
}

function handleDropdownValues(title){
  var count = 0;
  var valuesToHide = dropdownJSON[title]; // Use bracket notation for dynamic key
  $(".Popover__Value").each(function(){
    const text = $(this).text().trim();
    const shouldHide = valuesToHide.some(value => text.includes(value));
    if (shouldHide) {
      $(this).addClass("hide");
    } else {
      $(this).removeClass("hide");
    }
  });
  $(".ProductForm__Option.Diamond.Coverage").next().find(".Popover__Content").find(".Popover__Value").each(function () {
    if (!$(this).hasClass("hide") && count === 0) {
      $(this).get(0).click();
      count++;
    }
  });
}

/* Remove Values after ? and return onlt Text */
function refactorParameter(param) {
  if (param) {
    param = param.split(/[?&]/)[0];
    param = param.replace(/[^a-zA-Z0-9 ().]/g, ' ');
  }
  return param;
}

/* Carat Weight Product Dropdown */
function caratWeightDropDown(v) {
  jQuery('#caratWeightWrapper').html("")
  var htmlDiv = ''
  var fetchSelectedCaratWeight = (getParameterByName("carat-weight") && getParameterByName("carat-weight") != null) ? refactorParameter(getParameterByName("carat-weight")) : getCaratWeightSelectedOption

  if (v) {
    htmlDiv += `<div class="ProductForm__Option carat-weight-dropdown">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-carat-weight-dropdown-options" type="button" class="ProductForm__Item carat_weight_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-carat-weight-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">Carat Weight:</span><span class="ProductForm__SelectedValuCaratWeight` + v.id + ` dropdown-selected-value">` + fetchSelectedCaratWeight + `</span></span>`
    htmlDiv += `<input type="hidden" name="properties[Carat_Weight]" class="carat_weight_dropdown_title` + v.id + `_selectedvalue" value="` + fetchSelectedCaratWeight + `">`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-carat-weight-dropdown-options" class="OptionSelector carat_weight_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">Carat Weight</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList carat-weight-dropdown" data-scrollable="">`;
    for (var j = 0; j < getCaratWeightOptions.length; j++) {
      var variant = getCaratWeightOptions[j];
      var redirectProductUrl = variant.url.indexOf('?') !== -1 ? variant.url + '&carat-weight=' + variant.title : variant.url + '?carat-weight=' + variant.title;
      htmlDiv += `<a class="hide-underline" href="` + redirectProductUrl + `"><button type="button" class="carat_weight_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-title="` + variant.variant_name + `" data-value="` + variant.variant_name + `">`;
      htmlDiv += `<span class="dropdown-title">` + variant.title + `</span>`;
      htmlDiv += `</button></a>`;
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    if ($(".ProductForm__Option.Size").length !== 0 && $(".ProductForm__Option.custom-size-dropdown.Diamond.Coverage").length === 0) {
      $(".ProductForm__Option.Size").before(htmlDiv)
    } else if($(".ProductForm__Option.custom-size-dropdown.Diamond.Coverage").length !== 0){
      $(".ProductForm__Option.custom-size-dropdown.Diamond.Coverage").before(htmlDiv)
    } else {
      $('#caratWeightWrapper').append(htmlDiv)
    }
    $('body').css("overflow", "visible");
    enableAddToCartButton()
    setClickActionCaratWeight()
    stopScreenFreeze()
  } else {
    console.log("option2 is not a number")
  }
}

/* Mens size dropdown */
function mensSizeDropDown(v) {
  var checkLeadTimeTag = currentProductJson.tags.filter(s => s.includes('hide-pdp-lead-time'));
  jQuery('#menssizeWrapper').html("")
  var htmlDiv = ''
  var appendArray = []
  if (v) {
    htmlDiv += `<div class="ProductForm__Option mensize-dropdown">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-mensize-dropdown-options" type="button" class="ProductForm__Item mensize_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-mensize-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">Size </span><span class="ProductForm__SelectedValueMens` + v.id + ` dropdown-selected-value">Select</span></span>` 
    htmlDiv += `<input type="hidden" name="properties[Size]" class="mensize_dropdown_title` + v.id + `_selectedvalue" value=''>`;
    htmlDiv += `<input type="hidden" name="properties[_mensize_v_id]" class="mensize_dropdown_` + v.id + `_selectedvalue" value='' data-required='true'>`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-mensize-dropdown-options" class="OptionSelector mensize_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">Mens size</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList mensize-dropdown" data-scrollable="">`;
    for (var j = 0; j < mensSizeOptions.length; j++) {
      var variant = mensSizeOptions[j];
      htmlDiv += `<button type="button" class="mensize_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" image-url="` + variant.imageUrl + `" index="` + j + `" data-price="` + variant.price + `" data-title="` + variant.title + `" data-value="` + variant.id + `">`;
      htmlDiv += `<span class="dropdown-title">` + variant.title + `</span>`;
      if (variant.title != `I don't know my size; send me a Ring Sizing Gauge!` && checkLeadTimeTag && checkLeadTimeTag.length == 0) {
        htmlDiv += `<span class="popover-value-stock"><span class="custom-made-color">Made to Order</span> </span>`;
      }
      htmlDiv += `</button>`;
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    jQuery('#menssizeWrapper').append(htmlDiv)
    enableAddToCartButton()
    setClickActionMensize()
    stopScreenFreeze()
  } else {
    console.log("option2 is not a number")
  }
}

/* Font family dropdown */
function fontFamilyDropDown(v) {
  var getProductFontFamliy = [];
  if (getFontFamily && getFontFamily != '') {
    getProductFontFamliy = Object.values(getFontFamily);
    var getFirstFontFamily = Object.values(getFontFamily)[0];
    jQuery('#fontFamilyWrapper').html("")
    var htmlDiv = ''
    var appendArray = []
    if (v) {
      htmlDiv += `<div class="ProductForm__Option fontfamily-dropdown">`;
      htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-fontfamily-dropdown-options" type="button" class="ProductForm__Item fontfamily_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-fontfamily-dropdown-options">`;
      htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">Font Family: </span><span class="ProductForm__SelectedValueFonts` + v.id + ` dropdown-selected-value get-selected-font-family-value">` + getFirstFontFamily + `</span></span>`
      htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
      htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
      htmlDiv += `</svg>`;
      htmlDiv += `</button></div>`;
      var htmlDivPop = '';
      htmlDivPop += `<div id="popover-` + v.id + `-product-template-fontfamily-dropdown-options" class="OptionSelector fontfamily_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
      htmlDivPop += `<header class="Popover__Header">`;
      htmlDivPop += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
      htmlDivPop += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
      htmlDivPop += `</svg></button>`;
      htmlDivPop += `<span class="Popover__Title Heading u-h4">Font Family</span>`;
      htmlDivPop += `</header>`
      htmlDivPop += `<div class="Popover__Content">`;
      htmlDivPop += `<div class="Popover__ValueList fontfamily-dropdown" data-scrollable="">`;
      for (var j = 0; j < getProductFontFamliy.length; j++) {
        var variant = getProductFontFamliy[j];
        var trimFont = variant.replaceAll(/\s/g, '');
        htmlDivPop += `<button type="button" class="fontfamily_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-price="` + v.price + `" data-title="` + variant + `" data-value="` + v.id + `"">`;
        htmlDivPop += `<span class="dropdown-title" style="font-family:` + trimFont + `">` + variant + `</span>`;
        htmlDivPop += `</button>`;
      }
      htmlDivPop += `</div>`;
      htmlDivPop += `</div>`;
      htmlDivPop += `</div>`;

      jQuery('.Product__Wrapper').after(htmlDivPop)
      jQuery('#fontFamilyWrapper').append(htmlDiv)
      enableAddToCartButton()
      setClickActionFontFamily()
      stopScreenFreeze()
      $('#engravablesInputsWrapperSlider').removeClass('hide') /* Show Engraving Toggle */
    } else {
      console.log("option2 is not a number")
    }
  }
}

/* Womens size dropdown */
function womensSizeDropDown(v) {
  var checkLeadTimeTag = currentProductJson.tags.filter(s => s.includes('hide-pdp-lead-time'));
  jQuery('#womenssizeWrapper').html("")
  var htmlDiv = ''
  var appendArray = []
  if (v) {
    htmlDiv += `<div class="ProductForm__Option womensize-dropdown">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-womensize-dropdown-options" type="button" class="ProductForm__Item womensize_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-womensize-dropdown-options">`;
    htmlDiv += `<span class="ProductForm__OptionName "><span class="dropdown-lable">Size: <a href="javascript:void(0)" onclick="openSizeDrawer()" class="manage-custom-size custom-all-size-guide" tabindex="0">Size Guide</a> </span><span class="ProductForm__SelectedValueWomens` + v.id + ` dropdown-selected-value">Select</span></span>` 
    htmlDiv += `<input type="hidden" name="properties[Size]" class="womensize_dropdown_title` + v.id + `_selectedvalue" value=''>`;
    htmlDiv += `<input type="hidden" name="properties[_womensize_v_id]" class="womensize_dropdown_` + v.id + `_selectedvalue" value='' data-required='true'>`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-womensize-dropdown-options" class="OptionSelector womensize_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">Womens size</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList womensize-dropdown" data-scrollable="">`;
    for (var j = 0; j < womensSizeOptions.length; j++) {
      var variant = womensSizeOptions[j];
      htmlDiv += `<button type="button" class="womensize_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" image-url="` + variant.imageUrl + `" index="` + j + `" data-price="` + variant.price + `" data-title="` + variant.title + `" data-value="` + variant.id + `">`;
      htmlDiv += `<span class="dropdown-title">` + variant.title + `</span>`;
      if (variant.title != `I don't know my size; send me a Ring Sizing Gauge!` && checkLeadTimeTag && checkLeadTimeTag.length == 0) {
        htmlDiv += `<span class="popover-value-stock"><span class="custom-made-color">Made to Order</span> </span>`;
      }
      htmlDiv += `</button>`;
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    jQuery('#womenssizeWrapper').append(htmlDiv)
    enableAddToCartButton()
    setClickActionwomensize()
    stopScreenFreeze()
  } else {
    console.log("option2 is not a number")
  }
}

/* ======= Update pricing for Customizable Locket on variant select ======= */
/* ======= GLOBAL STATE ======= */
let originalBasePrice = null;
let originalCompareAtPrice = null;
let originalSalePrice = null;   /* NEW: VIP/VVIP/Global sale line */
let selectedAddons = {}; // { key: price }
let selectedSaleAddons = {}; // { key: stone's sale/VIP/VVIP price for active mode }

/* ======= INIT BASE PRICE (ONLY ONCE) ======= */
function initBasePrice() {
  let text = $('#appendReg').text(); /* Original Price */
  originalBasePrice = parseFloat(text.replace(/[^0-9.]/g, ''));
  if (isNaN(originalBasePrice)) {
    console.error('Base price parsing failed:', text);
    originalBasePrice = 0;
  }
}

/* ======= INIT COMPARE AT PRICE (ONLY ONCE) ======= */
function initCompareAtPrice() {
  let text = $('#appendCompareAt').text(); /* Compare at/Sale Price */
  originalCompareAtPrice = parseFloat(text.replace(/[^0-9.]/g, ''));
  if (isNaN(originalCompareAtPrice)) {
    console.error('Base price parsing failed:', text);
    originalCompareAtPrice = 0;
  }
}

/* ======= INIT SALE PRICE (ONLY ONCE) ======= */
function initSalePrice() {
  originalSalePrice = 0;
  var variant = currentVariantJson;
  if (!variant) return;
  var checkVisitingCustomer = localStorage.getItem("setVisitingCustomer");
  var checkVisitingCustomerPrivateSale = localStorage.getItem("setVisitingCustomerPrivateSale");
  var vipPrice  = getVariantMetafieldValue(variant.id, 'vip_price')  && isFinite(getVariantMetafieldValue(variant.id, 'vip_price')?.amount)  ? parseFloat(getVariantMetafieldValue(variant.id, 'vip_price').amount)  : 0;
  var vvipPrice = getVariantMetafieldValue(variant.id, 'vvip_price') && isFinite(getVariantMetafieldValue(variant.id, 'vvip_price')?.amount) ? parseFloat(getVariantMetafieldValue(variant.id, 'vvip_price').amount) : 0;

  if (showSalePriceGlobal === true) {
    originalSalePrice = getVariantMetafieldValue(variant.id, 'sale_price') ? parseFloat(getVariantMetafieldValue(variant.id, 'sale_price').amount) : 0;
  }
  if (showVIPPriceGlobal === true && checkVisitingCustomer === getVIPParam) originalSalePrice = vipPrice;
  if (showVVIPPriceGlobal === true && checkVisitingCustomer === getVVIPParam) originalSalePrice = vvipPrice;
  if (showVIPPrivateSale === true && checkVIPUser === true && checkVisitingCustomerPrivateSale === getVIPParamPrivateSale) originalSalePrice = vipPrice;
  if (showVVIPPrivateSale === true && checkVVIPUser === true && checkVisitingCustomerPrivateSale === getVVIPParamPrivateSale) originalSalePrice = vvipPrice;
}

/* Returns the stone variant's add-on price for the active pricing mode
   (global sale / VIP / VVIP), mirroring getVariantSkuDetails precedence.
   Falls back to the stone's normal price when no mode applies or the
   relevant metafield is missing. */
function getStoneSalePrice(stoneVariantId, stoneMainPrice) {
  var saleMap = window.__locketCharmSalePrices || {};
  var vipMap  = window.__locketCharmVipPrices  || {};
  var vvipMap = window.__locketCharmVvipPrices || {};
  var id = String(stoneVariantId);
  var stoneSale = parseFloat(saleMap[id]);
  var stoneVip  = parseFloat(vipMap[id]);
  var stoneVvip = parseFloat(vvipMap[id]);

  var checkVisitingCustomer = localStorage.getItem("setVisitingCustomer");
  var checkVisitingCustomerPrivateSale = localStorage.getItem("setVisitingCustomerPrivateSale");

  var result = parseFloat(stoneMainPrice) || 0;  /* fallback: normal price */

  /* Global sale: all visitors (set first, lowest precedence) */
  if (showSalePriceGlobal === true && isFinite(stoneSale) && stoneSale > 0) {
    result = stoneSale;
  }
  /* VIP overrides */
  if ((showVIPPriceGlobal === true && checkVisitingCustomer === getVIPParam) ||
      (showVIPPrivateSale === true && checkVIPUser === true && checkVisitingCustomerPrivateSale === getVIPParamPrivateSale)) {
    if (isFinite(stoneVip) && stoneVip > 0) result = stoneVip;
  }
  /* VVIP overrides */
  if ((showVVIPPriceGlobal === true && checkVisitingCustomer === getVVIPParam) ||
      (showVVIPPrivateSale === true && checkVVIPUser === true && checkVisitingCustomerPrivateSale === getVVIPParamPrivateSale)) {
    if (isFinite(stoneVvip) && stoneVvip > 0) result = stoneVvip;
  }
  return result;
}

/* ======= MAIN PRICE UPDATE FUNCTION ======= */
function updateMainPrice(grabPrice, key) {
  if (originalBasePrice === null) {
    initBasePrice();
  }
  let price = parseFloat(grabPrice) || 0;
  // Detect format
  if (price > 1000) {
    price = price / 100;
  }
  
  selectedAddons[key] = price; /* Store/update */

  // Sum all addons
  let totalAddonPrice = 0;
  Object.values(selectedAddons).forEach(val => {
    totalAddonPrice += val;
  });

  const finalPrice = originalBasePrice + totalAddonPrice;
  $('#appendReg').text('$' + Math.round(finalPrice).toLocaleString());
}

/* ======= COMPARE AT PRICE UPDATE FUNCTION ======= */
function updateCompareAtPrice(grabPrice, key) {
  if (originalCompareAtPrice === null) {
    initCompareAtPrice();
  }
  let price = parseFloat(grabPrice) || 0;
  // Detect format
  if (price > 1000) {
    price = price / 100;
  }
  
  selectedAddons[key] = price; /* Store/update */

  // Sum all addons
  let totalAddonPrice = 0;
  Object.values(selectedAddons).forEach(val => {
    totalAddonPrice += val;
  });

  var finalPrice = 0;
  if(originalCompareAtPrice > 0){
    finalPrice = originalCompareAtPrice + totalAddonPrice;
  }
  if(finalPrice <= 0) {
    $('#appendCompareAt').text('');
  } else {
    $('#appendCompareAt').text('$' + formatPriceFunc(Number(finalPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})));
  }
}

/* ======= SALE PRICE UPDATE FUNCTION (VIP / VVIP / Global Sale) ======= */
function updateSalePrice(grabPrice, key) {
  if (originalSalePrice === null) initSalePrice();
  if (!originalSalePrice || originalSalePrice <= 0) return;
  if (key) {
    let price = parseFloat(grabPrice) || 0;
    if (price > 1000) price = price / 100;
    selectedSaleAddons[key] = price;
  }
  let total = 0;
  Object.values(selectedSaleAddons).forEach(v => { total += v; });
  const finalPrice = originalSalePrice + total;
  $('#appendSale').text('$' + formatPriceFunc(Number(finalPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })));
}

jQuery(".ProductForm__Item").click(function () {
  var action_control = $(this).attr('aria-controls')
  var id = $(this).attr('id')
  closedPopOver(action_control)
  jQuery(".emeraldstone_dropdown_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".emeraldstone_dropdown_popover").attr('aria-hidden', true)
    }
  })
  jQuery(".carat_weight_dropdown_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".carat_weight_dropdown_popover").attr('aria-hidden', true)
      jQuery(".carat_weight_drop_down").attr('aria-expanded', false)
    }
  })
  jQuery(".custom_size_meta_dropdown_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".custom_size_meta_dropdown_popover").attr('aria-hidden', true)
      jQuery(".custom_size_meta_drop_down").attr('aria-expanded', false)
    }
  })
  jQuery(".custom_size_meta_dropdown_popover_2").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".custom_size_meta_dropdown_popover_2").attr('aria-hidden', true)
      jQuery(".custom_size_meta_drop_down_2").attr('aria-expanded', false)
    }
  })
  jQuery(".zodiac_one_dropdown_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".zodiac_one_dropdown_popover").attr('aria-hidden', true)
    }
  })
  jQuery(".zodiac_two_dropdown_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".zodiac_two_dropdown_popover").attr('aria-hidden', true)
    }
  })
  jQuery(".engravable_dropdown_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".engravable_dropdown_popover").attr('aria-hidden', true)
    }
  })
  jQuery(".pearstone_dropdown_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".pearstone_dropdown_popover").attr('aria-hidden', true)
    }
  })
  jQuery(".womens_dropdown_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".womensize_dropdown_popover").attr('aria-hidden', true)
    }
  })
  jQuery(".mensize_drop_down").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".mensize_dropdown_popover").attr('aria-hidden', true)
    }
  })
  jQuery(".custom_size_dropdown").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".custom_size_dropdown_popover").attr('aria-hidden', true)
    }
  })
  jQuery(".color_dropdown_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".color_dropdown_popover").attr('aria-hidden', true)
    }
  })
  jQuery(".custom_stone_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
      jQuery(".custom_stone_popover").attr('aria-hidden', true)
    }
  })
  if ($(this).attr("aria-expanded") == "false") {
    $("body").addClass("is-rc-open").removeClass("is-rc-close");
  } else {
    $("body").removeClass("is-rc-open").addClass("is-rc-close");
  }
})

/** Closing popover dropdown on click of size chart **/
$(".Popover__FooterHelp").click(function () {
  $(".Popover").removeAttr("aria-hidden")
  $(".PageOverlay").removeClass("is-visible")
  $(".ProductForm__Item").attr("aria-expanded", "false")
});
$(".ProductForm__SelectedValue").click(function () {
  if ($(".Popover").css("visibility") == 'hidden') {
    $(".Popover").css("visibility", "visible");
  }
});
$(".Popover__FooterHelp").click(function () {
  if ($("#modal-size-chart").attr("aria-hidden") == 'true') {
    $('html').css("overflow-y", "hidden");
    $(".PageOverlay").click();
  }
})
$(".Modal__Close").click(function () {
  $('html').css("overflow-y", "visible");
})

/** Closing popover on click of dropdown buttons **/
$('.ProductForm__Item').click(function () {
  if (($(window).width() < 980) === true) {
    setTimeout(function () {
      $(".PageOverlay").addClass('is-visible')
    }, 100);
  }
  var x = $(this).attr('aria-expanded')
  if (x == 'true') {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'visible';
  }
});

function setClickActionDiamondCoverage() {
  jQuery(".diamond_coverage_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var top = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 135 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        setTimeout(function () {
          $(".PageOverlay").addClass('is-visible')
          tops = windowWidth - 140
        }, 100);
      }

      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible");
      jQuery("#" + id).attr('aria-expanded', false);
    });
    $('body').css("overflow", "hidden");
  })
  popoverClosed()
}

function setClickActionPearstone() {
  jQuery(".pearstone_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 100 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }

      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible")
    });
  })
  popoverClosed()
}

function setClickActionEmeraldstone() {
  jQuery(".emeraldstone_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 100 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible")
    });
  })
  popoverClosed()
}

function setClickActionCaratWeight() {
  jQuery(".carat_weight_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 10 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
  })
  popoverClosed()
}

function setClickActionZodiacOne() {
  jQuery(".zodiac_one_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 100 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible")
    });
  })
  popoverClosed()
}

function setClickActionZodiacTwo() {
  jQuery(".zodiac_two_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 100 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible")
    });
  })
  popoverClosed()
}

function setClickActionCustomSize() {
  jQuery(".custom_size_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 135 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible")
    });
  })
  popoverClosed()
}

function setClickActionMensize() {
  jQuery(".mensize_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var top = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 100 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        setTimeout(function () {
          $(".PageOverlay").addClass('is-visible')
          tops = windowWidth - 140
        }, 100);
      }

      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible");
      jQuery("#" + id).attr('aria-expanded', false);
    });
    $('body').css("overflow", "hidden");
  })
  popoverClosed()
}

function fontFamilyWrapper() {
  jQuery(".fontfamily_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var top = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 135 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }

      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible")
    });
  })
  popoverClosed()
}

function setClickActionCharmCount() {
  jQuery(".charmcount_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var top = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 135 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        setTimeout(function () {
          $(".PageOverlay").addClass('is-visible')
          tops = windowWidth - 140
        }, 100);
      }

      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible");
      jQuery("#" + id).attr('aria-expanded', false);
    });
    $('body').css("overflow", "hidden");
  })
  popoverClosed()
}

function setClickActionwomensize() {
  jQuery(".womensize_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var top = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 135 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        setTimeout(function () {
          $(".PageOverlay").addClass('is-visible')
          tops = windowWidth - 140
        }, 100);
      }

      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible");
      jQuery("#" + id).attr('aria-expanded', false);
    });
    $('body').css("overflow", "hidden");
  })
  popoverClosed()
}

function setClickActionFontFamily() {
  jQuery(".fontfamily_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var top = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 135 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }

      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible")
    });
    $('body').css("overflow", "hidden");
  })
  popoverClosed()
}

function customHeart(v) {
  var optionsHtml = ""
  var vals = getOptionsVals(v, 'Hearts')
  if (!vals) {
    vals = getOptionsVals(v, 'Heart Count')
  }
  var vals1 = getOptionsVals(v, 'Engraving Font')
  if (vals !== '' && ["Finish without engraving", "finish without engraving", "finished without engraving", "without engraving", "Without Engraving", "No Engraving", "no engraving"].indexOf(vals1) === -1) {
    // Perform operations only of option3 is not equals to "Finish without engraving"
    if (vals == "1 Large + 1 Mini") {
      optionsHtml = `<p class="line-item-property__field">
        <input data-required="true" maxlength="3" type="text" id="large_heart_text" name="properties[Large Heart Text]" placeholder="Large Heart Text" class="vow-form-control vow-form-control-light">
          <span id="large_heart_text_preview" class="preview-text"></span>
          <span class="errormsg hide heart-wrap-error"></span>
          </p>
        <p class="line-item-property__field" style="margin-bottom:15px;">
        <input data-required="true" maxlength="1" type="text" id="first_mini_heart_text" name="properties[First Mini Heart Text]" placeholder="First Mini Heart Text" class="vow-form-control vow-form-control-light">
            <span id="first_mini_heart_text_preview" class="preview-text"></span><span class="errormsg hide heart-wrap-error"></span>
        </p>`
    } else if (vals == "1 Large + 2 Minis") {
      optionsHtml = `<p class="line-item-property__field">
        <input data-required="true" maxlength="3" type="text" id="large_heart_text" name="properties[Large Heart Text]" placeholder="Large Heart Text" class="vow-form-control vow-form-control-light">
          <span id="large_heart_text_preview" class="preview-text"></span>
            <span class="errormsg hide heart-wrap-error"></span>
          </p>
        <p class="line-item-property__field">
        <input data-required="true" maxlength="1" type="text" id="first_mini_heart_text" name="properties[First Mini Heart Text]" placeholder="First Mini Heart Text" class="vow-form-control vow-form-control-light">
          <span id="first_mini_heart_text_preview" class="preview-text"></span>
            <span class="errormsg hide heart-wrap-error"></span>
          </p>
        <p class="line-item-property__field" style="margin-bottom:15px;">
        <input data-required="true" maxlength="1" type="text" id="second_mini_heart_text" name="properties[Second Mini Heart Text]" placeholder="Second Mini Heart Text" class="vow-form-control vow-form-control-light">
          <span id="second_mini_heart_text_preview" class="preview-text"></span>
            <span class="errormsg hide heart-wrap-error"></span>
          </p>`
    } else if (vals == "1 Large + 3 Minis") {
      optionsHtml = `<p class="line-item-property__field">
        <input data-required="true" maxlength="3" type="text" id="large_heart_text" name="properties[Large Heart Text]" placeholder="Large Heart Text" class="vow-form-control vow-form-control-light">
          <span id="large_heart_text_preview" class="preview-text"></span>
            <span class="errormsg hide heart-wrap-error"></span>
          </p>
        <p class="line-item-property__field">
          <input data-required="true" maxlength="1" type="text" id="first_mini_heart_text" name="properties[First Mini Heart Text]" placeholder="First Mini Heart Text" class="vow-form-control vow-form-control-light">
          <span id="first_mini_heart_text_preview" class="preview-text"></span>
            <span class="errormsg hide heart-wrap-error"></span>
          </p>
        <p class="line-item-property__field">
        <input data-required="true" maxlength="1" type="text" id="second_mini_heart_text" name="properties[Second Mini Heart Text]" placeholder="Second Mini Heart Text" class="vow-form-control vow-form-control-light">
          <span id="second_mini_heart_text_preview" class="preview-text"></span>
            <span class="errormsg hide heart-wrap-error"></span>
          </p>
        <p class="line-item-property__field" style="margin-bottom:15px;">
        <input data-required="true" maxlength="1" type="text" id="third_mini_heart_text" name="properties[Third Mini Heart Text]" placeholder="Third Mini Heart Text" class="vow-form-control vow-form-control-light">
          <span id="third_mini_heart_text_preview" class="preview-text"></span>
            <span class="errormsg hide heart-wrap-error"></span>
          </p>`
    } else if (vals == "1 Large + 4 Minis") {
      optionsHtml = `<p class="line-item-property__field">
        <input data-required="true" maxlength="3" type="text" id="large_heart_text" name="properties[Large Heart Text]" placeholder="Large Heart Text" class="vow-form-control vow-form-control-light">
            <span id="large_heart_text_preview" class="preview-text"></span>
            <span class="errormsg hide heart-wrap-error"></span>
          </p>
        <p class="line-item-property__field">
        <input data-required="true" maxlength="1" type="text" id="first_mini_heart_text" name="properties[First Mini Heart Text]" placeholder="First Mini Heart Text" class="vow-form-control vow-form-control-light">
          <span id="first_mini_heart_text_preview" class="preview-text"></span>
            <span class="errormsg hide heart-wrap-error"></span>
          </p>
          <p class="line-item-property__field">
          <input data-required="true" maxlength="1" type="text" id="second_mini_heart_text" name="properties[Second Mini Heart Text]" placeholder="Second Mini Heart Text" class="vow-form-control vow-form-control-light">
          <span id="second_mini_heart_text_preview" class="preview-text"></span>
            <span class="errormsg hide heart-wrap-error"></span>
          </p>
        <p class="line-item-property__field">
        <input data-required="true" maxlength="1" type="text" id="third_mini_heart_text" name="properties[Third Mini Heart Text]" placeholder="Third Mini Heart Text" class="vow-form-control vow-form-control-light">
            <span id="third_mini_heart_text_preview" class="preview-text"></span>	  
            <span class="errormsg hide heart-wrap-error"></span>
          </p>
        <p class="line-item-property__field" style="margin-bottom:15px;">
        <input data-required="true" maxlength="1" type="text" id="fourth_mini_heart_text" name="properties[Fourth Mini Heart Text]" placeholder="Fourth Mini Heart Text" class="vow-form-control vow-form-control-light">
          <span id="fourth_mini_heart_text_preview" class="preview-text"></span>
            <span class="errormsg hide heart-wrap-error"></span>
          </p>`
    }
  }
  var getFontFamily = getOptionsVals(v, 'Engraving Font')
  if (getFontFamily == 'Bernhard Tango') {
    getFontFamily = 'BernhardTangoBT';
  }
  if (getFontFamily == 'AVERY' || getFontFamily == 'Arial-Black' || getFontFamily == 'Seagramftb') {
    $('.preview-text').css('letter-spacing', '-3px')
  }
  jQuery("#customHeartWrapper").html(optionsHtml)
  /* Preview Text acc. to Font-Family */
  $('#large_heart_text').on('keyup', function () {
    var getValue = $('#large_heart_text').val();
    if (getFontFamily) {
      $('#large_heart_text_preview').css('font-family', getFontFamily.replaceAll(/\s/g, ''))
      $('#large_heart_text_preview').text(getValue);
    }
  });
  $('#first_mini_heart_text').on('keyup', function () {
    var getValue = $('#first_mini_heart_text').val();
    if (getFontFamily) {
      $('#first_mini_heart_text_preview').css('font-family', getFontFamily.replaceAll(/\s/g, ''))
      $('#first_mini_heart_text_preview').text(getValue);
    }
  });
  $('#second_mini_heart_text').on('keyup', function () {
    var getValue = $('#second_mini_heart_text').val();
    if (getFontFamily) {
      $('#second_mini_heart_text_preview').css('font-family', getFontFamily.replaceAll(/\s/g, ''))
      $('#second_mini_heart_text_preview').text(getValue)
    };
  });
  $('#third_mini_heart_text').on('keyup', function () {
    var getValue = $('#third_mini_heart_text').val();
    if (getFontFamily) {
      $('#third_mini_heart_text_preview').css('font-family', getFontFamily.replaceAll(/\s/g, ''))
      $('#third_mini_heart_text_preview').text(getValue);
    }
  });
  $('#fourth_mini_heart_text').on('keyup', function () {
    var getValue = $('#fourth_mini_heart_text').val();
    if (getFontFamily) {
      $('#fourth_mini_heart_text_preview').css('font-family', getFontFamily.replaceAll(/\s/g, ''))
      $('#fourth_mini_heart_text_preview').text(getValue)
    };
  });
  enableAddToCartButton()
}

function customMiniHeart(v) {
  var optionsHtml = ""
  var mb = jQuery("#customHeartWrapper").length ? 'style="margin-top:15px;"' : ''
  var vals = getOptionsVals(v, 'Engraving Font')
  // Perform operations only of option3 is not equals to "Finish without engraving"
  if (["Finish without engraving", "finish without engraving", "finished without engraving", "without engraving", "Without Engraving", "No Engraving", "no engraving"].indexOf(vals) === -1) {
    optionsHtml = `<p class="line-item-property__field">
   <input data-required="true" type="text" maxlength="1" `+ mb + ` name="properties[Mini Heart 1]" placeholder="Heart 1" class="vow-form-control vow-form-control-light">
  </p>
  <p class="line-item-property__field">
   <input data-required="true" type="text" maxlength="1" name="properties[Mini Heart 2]" placeholder="Heart 2" class="vow-form-control vow-form-control-light">
  </p>
  <p class="line-item-property__field">
   <input data-required="true" type="text" maxlength="1" name="properties[Mini Heart 3]" placeholder="Heart 3" class="vow-form-control vow-form-control-light">
  </p>
  <p class="line-item-property__field">
   <input data-required="true" type="text" maxlength="1" name="properties[Mini Heart 4]" placeholder="Heart 4" class="vow-form-control vow-form-control-light">
  </p>
  <p class="line-item-property__field" style="margin-bottom:15px;">
   <input data-required="true" type="text" maxlength="1" name="properties[Mini Heart 5]" placeholder="Heart 5" class="vow-form-control vow-form-control-light">
  </p>`
  }
  jQuery("#customMiniHeartWrapper").html(optionsHtml)
  enableAddToCartButton();
}

/** Closing popover on click of body **/
$(document).mouseup(function (e) {
  var container = $(".ProductForm");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".combine_product_bottom_two_drop_down,.engravable_dropdown_popover,.engravable_placement_dropdown_popover,.combine_product_bottom_one_drop_down,.combine_product_drop_down,.custom_size_dropdown_popover, .carat_weight_dropdown_popover, .custom_size_meta_dropdown_popover, .custom_size_meta_dropdown_popover_2 .zodiac_one_dropdown_popover,.zodiac_two_dropdown_popover,.engravable_dropdown_popover,.emeraldstone_dropdown_popover,.pearstone_dropdown_popover,.womensize_dropdown_popover,.mensize_dropdown_popover,.color_dropdown_popover,.custom_stone_popover,.fontfamily_dropdown_popover").attr('aria-hidden', true)
    $(".carat_weight_drop_down").attr('aria-expanded', false)
    $(".custom_size_meta_drop_down").attr('aria-expanded', false)
    $(".engravable_drop_down").attr('aria-expanded', false)
    $(".engravable_placement_drop_down").attr('aria-expanded', false)
    $(".custom_size_drop_down").attr('aria-expanded', false)
    $(".combine_product_drop_down").attr('aria-expanded', false)
    $(".combine_product_bottom_one_drop_down").attr('aria-expanded', false)
    $(".combine_product_bottom_two_drop_down").attr('aria-expanded', false)
  }
  var container = $(".Cart-ProductForm");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".custom-complimentary-options").attr('aria-hidden', true)
  }
  document.body.style.overflow = 'visible';
  if ($("#Search").attr("aria-hidden") === true) $(".PageOverlay").removeClass('is-visible');
  if ($(".custom-complimentary-options").attr("aria-hidden") === "true") $(".PageOverlay").removeClass('is-visible');
});

function executeDontKnowYourSize(v) {
  var iDontKnowMySizePresent = false
  if (v && v.option1 && v.option1.indexOf("I don't know my size") !== -1) {
    iDontKnowMySizePresent = true
  } else if (v && v.option2 && v.option2.indexOf("I don't know my size") !== -1) {
    iDontKnowMySizePresent = true
  } else if (v && v.option3 && v.option3.indexOf("I don't know my size") !== -1) {
    iDontKnowMySizePresent = true
  }
  // Hide/Show the html
  if (iDontKnowMySizePresent) {
    $(".js-dontknowyoursize").hide()
  } else {
    $(".js-dontknowyoursize").show()
  }
}

function selectIdkVariant(e) {
  if ($(`button[data-value="I don't know my size; send me a Ring Sizing Gauge!"]`).length > 0) {
    $(`button[data-value="I don't know my size; send me a Ring Sizing Gauge!"]`).trigger("click")
  } else if ($(`button[data-value="I don't know my size; send me a ring sizing gauge!"]`).length > 0) {
    $(`button[data-value="I don't know my size; send me a ring sizing gauge!"]`).trigger("click")
  } else {
    console.log("No I dont know my size variant found in this product")
  }
}

/* *** Bespoke Stock Level warning functionality *** */
/* Show/Hide Bespoke warning popup */
function bespokeProductWarningPopup(variant) {
  if (currentVariantResponse) {
    for (var i = 0; i < currentVariantResponse.data.length; i++) {
      if (parseInt(currentVariantResponse.data[i].id) === parseInt(variant.id)) {
        variantData = currentVariantResponse.data[i];
      }
    }
    if (currentProductTemplate == 'bespoke-flash-product') {
      if (variantData.availableToSell <= 0) {
        $('#bespokeProductWarningPopup').show();
        $('#giftwrapCheckbox11').prop('checked', true);
        $('.BespokeradioWrapper').show();
        var getSelectedValue = $('.shippingPreference:checked').val();
        getSelectedValue == 'Yes'
          ? $('#giftwrapCheckbox11').prop('checked', true) && $('#giftwrapCheckbox12').prop('checked', false)
          : $('#giftwrapCheckbox12').prop('checked', true) && $('#giftwrapCheckbox11').prop('checked', false)
      } else {
        $('.BespokeradioWrapper').hide();
        $('#bespokeProductWarningPopup').hide();
      }
    }
  }
}

/* Bespoke modal Save value */
$('#bespokeProductWarningPopupOkButton').click(function () {
  var getSelectedValue = $('input[name="ShippingPreferenceValue"]:checked').val();
  getSelectedValue == 'Yes'
    ? $('#shippingPreferenceYes').prop('checked', true)
    : $('#shippingPreferenceNo').prop('checked', true)
  $('#bespokeProductWarningPopup').hide()
})

/* Search Preference tooltip */
function searchPreferenceToolTip() {
  $('#bespokeProductWarningPopup').show();
  var getSelectedValue = $('.shippingPreference:checked').val();
  getSelectedValue == 'Yes'
    ? $('#giftwrapCheckbox11').prop('checked', true) && $('#giftwrapCheckbox12').prop('checked', false)
    : $('#giftwrapCheckbox12').prop('checked', true) && $('#giftwrapCheckbox11').prop('checked', false)
}

/* Check checkbox only one at a time */
$('.shippingPreferenceModal').click(function () {
  $('.shippingPreferenceModal').not(this).prop('checked', false);
});

/* Close Bespoke Stock level warning popup */
function bespokeProductWarningPopupClose() {
  jQuery("#bespokeProductWarningPopup").hide()
}

/* Pre Order Functionality: Show sold out after specific orders (Inventory grabbed using Metafield) */
function preOrderFunctionality(variant) {
  var matchedVariant = null;
  /* Grabbing quantity of variant to sell for Pre order */
  $.each(getPreOrderVariantData, function (index, item) {
    if (parseInt(item.variant) === parseInt(variant.id)) {
      matchedVariant = item;
      return false;
    }
  });
  if (variant.inventory_policy === "continue" && matchedVariant !== null && variant.inventory_quantity <= -(matchedVariant.quantity) && variant.available === true) {
    $(".ProductForm__AddToCart").text('SOLD OUT').addClass('bespoke-sold-button');
    var changeStatus = 'deny';
    var refreshPage = false;
    updateContinueSellingStatus(variant.id, changeStatus, refreshPage)
    setTimeout(function () {
      $('.bespoke-sold-button').prop('disabled', true);
      $('.bespoke-sold-button').text('SOLD OUT')
    }, 10);
  }
}

/* Function to Update Continue Selling Status(Deny) */
async function updateContinueSellingStatus(variantId, changeStatus, refreshPage) {
  try {
    await new Promise((resolve, reject) => {
      $.ajax({
        type: 'PUT',
        url: `${portalApiUrl}/update-status/${variantId}/${changeStatus}`,
        success: function (response) {
          var productTags = currentProductJson ? currentProductJson.tags.join(",") : []
          if (productTags.indexOf("dont-show-in-stock-popup") === -1) {
            jQuery("#notifyWhenInStockPopup").show()
            jQuery(".ProductForm__AddToCart").hide()
          }
          resolve(response);
          if (refreshPage && refreshPage === true) {
            window.location.reload();
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          reject(textStatus);
        }
      });
    });
  } catch (error) {
    console.error(error);
    return null;
  }
}

/* Add Pre Order Quantity Value in Property */
function addPropertyForPreOrder(variant) {
  var matchedVariant = null;
  if ($("input[name='properties[_preOrderProduct]']").length !== 0) {
    $(".ProductForm__AddToCart").click(function () {
      $.each(getPreOrderVariantData, function (index, item) {
        if (item.variant === variant.id) {
          matchedVariant = item;
          return false;
        }
      });
      if (matchedVariant && matchedVariant !== null) {
        $("input[name='properties[_preOrderProduct]']").val(matchedVariant.quantity)
      } else {
        $("input[name='properties[_preOrderProduct]']").val("")
      }
    });
  }
}

/* This is for PDP accodridan which contains product details, shipping and exchange 
Create an accordion-style layout with toggle icons (plus/minus) that facilitates opening and closing tabs,
while also ensuring keyboard accessibility.*/
document.addEventListener('DOMContentLoaded', function () {
  var accordionItems = document.querySelectorAll('.accordion-item');
  accordionItems.forEach((item) => {
    var button = item.querySelector('.accordion-button');
    var content = item.querySelector('.accordion-content');
    var icon = item.querySelector('.accordion-icon');
    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', !expanded);
      content.style.display = expanded ? 'none' : 'block';
      icon.textContent = expanded ? '+' : '-';
      content.setAttribute('aria-hidden', expanded);
    });
    button.addEventListener('keydown', function (e) {
      var keyCode = e.which || e.keyCode;
      switch (keyCode) {
        case 13: // Enter key
        case 32: // Spacebar
          e.preventDefault();
          button.click();
          break;
        case 38: // Up arrow
          e.preventDefault();
          if (item.previousElementSibling) {
            item.previousElementSibling.querySelector('.accordion-button').focus();
          }
          break;
        case 40: // Down arrow
          e.preventDefault();
          if (item.nextElementSibling) {
            item.nextElementSibling.querySelector('.accordion-button').focus();
          }
          break;
      }
    });
  });
});

function redirectHref(event, url) {
  event.preventDefault();
  window.location.href = url;
}

/* Product Page: Swatches Accessibility */
function updateTabIndexes() {
  $('.ColorSwatch__Radio').each(function () {
    const $radio = $(this);
    const $label = $('label[for="' + $radio.attr('id') + '"]');
    if ($label.length) {
      if ($radio.prop('checked')) {
        $label.attr('tabindex', '0').attr('aria-checked', 'true').focus();
      } else {
        $label.attr('tabindex', '-1').attr('aria-checked', 'false');
      }
    }
  });
}

$(document).ready(function () {
  const $swatchLabels = $('.ColorSwatch');
  $swatchLabels.each(function () {
    $(this).on('keydown', function (e) {
      const $swatches = $('.ColorSwatch');
      const currentIndex = $swatches.index(document.activeElement);
      let nextIndex = currentIndex;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        nextIndex = (currentIndex + 1) % $swatches.length;
        $swatches.eq(nextIndex).focus();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        nextIndex = (currentIndex - 1 + $swatches.length) % $swatches.length;
        $swatches.eq(nextIndex).focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const inputId = $(this).attr('for');
        const $input = $('#' + inputId);

        if ($input.length) {
          $input.trigger('click');
          updateTabIndexes();
        }
      }
    });
  });
  updateTabIndexes();
});